import { useAutoAnimate } from '@formkit/auto-animate/react';
export { useAutoAnimate } from '@formkit/auto-animate/react';
import * as React73 from 'react';
import { forwardRef } from 'react';
import { HiX, HiCheck, HiMinus, HiChevronDown, HiChevronUp, HiOutlineUpload, HiOutlineEye, HiOutlineEyeOff, HiClock, HiOutlineChevronUp, HiOutlineCheck, HiOutlineX, HiOutlineRefresh, HiOutlineTrash, HiChevronLeft, HiChevronRight, HiCheckCircle, HiInformationCircle, HiExclamation, HiXCircle } from 'react-icons/hi';
import { clsx } from 'clsx';
import * as Primitive from '@radix-ui/react-alert-dialog';
import { twMerge } from 'tailwind-merge';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva } from 'class-variance-authority';
import { Slot } from '@radix-ui/react-slot';
import { DayPicker } from 'react-day-picker';
import { FiCalendar, FiChevronDown, FiChevronUp, FiCheck, FiClock, FiX, FiSearch, FiChevronRight, FiCircle, FiChevronLeft } from 'react-icons/fi';
import { format, set, addMinutes, isSameDay } from 'date-fns';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as SelectPrimitive from '@radix-ui/react-select';
import * as Primitive2 from '@radix-ui/react-checkbox';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { useRifm } from 'rifm';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as Primitive5 from '@radix-ui/react-progress';
import { CgSpinner } from 'react-icons/cg';
import { matchSorter } from 'match-sorter';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { useFloating, size, autoUpdate } from '@floating-ui/react-dom';
import { DismissableLayer } from '@radix-ui/react-dismissable-layer';
import { FocusScope } from '@radix-ui/react-focus-scope';
import { Root } from '@radix-ui/react-portal';
import { useComposedRefs, isString as isString$1 } from '@reach/utils';
import { useSelect, useMultipleSelection, useCombobox } from 'downshift';
import CountryList from 'country-list-with-dial-code-and-flag';
import Highlighter from 'react-highlight-words';
import { Command as Command$1 } from 'cmdk';
import { capitalCase } from 'change-case';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as Primitive6 from '@radix-ui/react-switch';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import * as TabsPrimitive2 from '@radix-ui/react-tabs';
import * as Primitive7 from '@radix-ui/react-toast';
import mitt from 'mitt';
import * as RechartsPrimitive from 'recharts';
export { Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';

// src/index.ts
var CloseButton = React73.forwardRef(
  (props, ref) => {
    const { className, defaultStyle = true, svgClass, ...rest } = props;
    const closeButtonClass = clsx(
      "close-btn",
      defaultStyle && "close-btn-default",
      className
    );
    return /* @__PURE__ */ React73.createElement("span", { className: closeButtonClass, role: "button", ...rest, ref }, /* @__PURE__ */ React73.createElement(HiX, { className: svgClass }));
  }
);
var ICONS = {
  success: {
    color: "text-emerald-500",
    icon: /* @__PURE__ */ React73.createElement(HiCheckCircle, { width: 20, height: 20, className: "w-5 h-5" })
  },
  info: {
    color: "text-blue-500",
    icon: /* @__PURE__ */ React73.createElement(HiInformationCircle, { width: 20, height: 20, className: "w-5 h-5" })
  },
  warning: {
    color: "text-yellow-500",
    icon: /* @__PURE__ */ React73.createElement(HiExclamation, { width: 20, height: 20, className: "w-5 h-5" })
  },
  danger: {
    color: "text-red-500",
    icon: /* @__PURE__ */ React73.createElement(HiXCircle, { width: 20, height: 20, className: "w-5 h-5" })
  }
};
var StatusIcon = React73.forwardRef(
  function StatusIcon2(props, forwardedRef) {
    const { type = "info", custom, iconColor, ...restProps } = props;
    const icon = ICONS[type];
    return /* @__PURE__ */ React73.createElement(
      "span",
      {
        ...restProps,
        className: clsx(`block ${iconColor || icon.color}`, restProps.className),
        ref: forwardedRef
      },
      custom || icon.icon
    );
  }
);

// src/components/alert.tsx
var TYPE_MAP = {
  success: {
    backgroundColor: "bg-emerald-50 dark:bg-emerald-500",
    titleColor: "text-emerald-700 dark:text-emerald-50",
    textColor: "text-emerald-500 dark:text-emerald-50",
    iconColor: "text-emerald-400 dark:text-emerald-50",
    icon: /* @__PURE__ */ React73.createElement(HiCheckCircle, null)
  },
  info: {
    backgroundColor: "bg-blue-50 dark:bg-blue-500",
    titleColor: "text-blue-700 dark:text-blue-100",
    textColor: "text-blue-500 dark:text-blue-100",
    iconColor: "text-blue-400 dark:text-blue-100",
    icon: /* @__PURE__ */ React73.createElement(HiInformationCircle, null)
  },
  warning: {
    backgroundColor: "bg-yellow-50 dark:bg-yellow-500",
    titleColor: "text-yellow-700 dark:text-yellow-50",
    textColor: "text-yellow-500 dark:text-yellow-50",
    iconColor: "text-yellow-400 dark:text-yellow-50",
    icon: /* @__PURE__ */ React73.createElement(HiExclamation, null)
  },
  danger: {
    backgroundColor: "bg-red-50 dark:bg-red-500",
    titleColor: "text-red-700 dark:text-red-100",
    textColor: "text-red-500 dark:text-red-100",
    iconColor: "text-red-400 dark:text-red-100",
    icon: /* @__PURE__ */ React73.createElement(HiXCircle, null)
  }
};
var Alert = React73.forwardRef(
  (props, forwardedRef) => {
    const {
      type = "warning",
      title,
      className,
      children,
      showIcon = false,
      customIcon,
      onClose,
      rounded = true,
      ...rest
    } = props;
    const typeMap = TYPE_MAP[type];
    const alertDefaultClass = "p-4 relative flex";
    const alertClass = clsx(
      "alert",
      alertDefaultClass,
      typeMap.backgroundColor,
      typeMap.textColor,
      !title ? "font-semibold" : "",
      onClose ? "justify-between" : "",
      onClose && !title ? "items-center" : "",
      "rounded-lg",
      className
    );
    return /* @__PURE__ */ React73.createElement("div", { ref: forwardedRef, className: alertClass, ...rest }, /* @__PURE__ */ React73.createElement("div", { className: `flex ${title ? "" : "items-center"}` }, showIcon && /* @__PURE__ */ React73.createElement(StatusIcon, { iconColor: typeMap.iconColor, custom: customIcon, type }), /* @__PURE__ */ React73.createElement("div", { className: showIcon ? "ltr:ml-2 rtl:mr-2" : void 0 }, title ? /* @__PURE__ */ React73.createElement("div", { className: `font-semibold mb-1 ${typeMap.titleColor}` }, title) : null, children)), onClose ? /* @__PURE__ */ React73.createElement("button", { type: "button", onClick: onClose }, /* @__PURE__ */ React73.createElement(CloseButton, { defaultStyle: false })) : null);
  }
);
var AlertDialog = Object.assign({}, Primitive, {
  Content: React73.forwardRef(
    function StyledContent(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive.Content,
        {
          ...props,
          ref: forwardedRef,
          className: clsx(
            "fixed bg-white px-4 py-2 rounded shadow top-20 max-h-[calc(100vh-6rem)] overflow-y-auto left-1/2 -translate-x-1/2",
            props.className
          )
        }
      );
    }
  ),
  Overlay: React73.forwardRef(
    function StyledOverlay(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive.Overlay,
        {
          ...props,
          ref: forwardedRef,
          className: clsx("fixed inset-0 bg-gray-500 opacity-70", props.className)
        }
      );
    }
  ),
  Title: React73.forwardRef(
    function StyledTitle(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive.Title,
        {
          ...props,
          ref: forwardedRef,
          className: clsx(
            "text-lg font-medium pb-2 min-w-[15rem] sm:min-w-[30rem]",
            props.className
          )
        }
      );
    }
  ),
  Footer: (props) => /* @__PURE__ */ React73.createElement("div", { ...props, className: clsx("flex gap-3 pt-2", props.className) })
});
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var Avatar = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  AvatarPrimitive.Root,
  {
    ref,
    className: cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className),
    ...props
  }
));
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  AvatarPrimitive.Image,
  {
    ref,
    className: cn("aspect-square h-full w-full", className),
    ...props
  }
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = React73.forwardRef(({ className, text, children, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  AvatarPrimitive.Fallback,
  {
    ref,
    className: cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      className
    ),
    ...props
  },
  text && abbreviate(text),
  children
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
var abbreviate = (text) => {
  const parts = text.trim().split(/\s+/);
  return (parts.length > 2 ? [parts[0], parts[parts.length - 1]] : parts).map((part) => part[0].toUpperCase()).join("");
};
var badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        primary: "bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-600/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Badge({ className, variant, ...props }) {
  return /* @__PURE__ */ React73.createElement("div", { className: cn(badgeVariants({ variant }), className), ...props });
}
function StatusField({ status, label, hideDot = false }) {
  const getStatusConfig = (status2) => {
    switch (status2) {
      case "pending":
        return { dotColor: "bg-gray-400", textColor: "text-gray-500" };
      case "info":
        return { dotColor: "bg-blue-500", textColor: "text-blue-600" };
      case "success":
        return { dotColor: "bg-green-500", textColor: "text-green-600" };
      case "warn":
        return { dotColor: "bg-yellow-500", textColor: "text-yellow-600" };
      case "danger":
        return { dotColor: "bg-red-500", textColor: "text-red-600" };
    }
  };
  const { dotColor, textColor } = getStatusConfig(status);
  return /* @__PURE__ */ React73.createElement("div", { className: "flex items-center space-x-2", role: "status", "aria-label": `Status: ${label}` }, !hideDot && /* @__PURE__ */ React73.createElement("div", { className: cn("w-2 h-2 rounded-full", dotColor), "aria-hidden": "true" }), /* @__PURE__ */ React73.createElement("span", { className: cn("text-sm", textColor) }, label));
}
var buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus:outline-none focus:ring-2 focus:border-primary-600 focus:ring-primary-500 focus:ring-opacity-50 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-white border border-gray-300 dark:bg-gray-700 dark:border-gray-700 text-gray-600 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-600 active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        solid: "bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-600",
        twoTone: "bg-primary-50 dark:bg-primary-500 dark:bg-opacity-20 text-primary-600 dark:text-primary-50 hover:bg-primary-100 dark:hover:bg-primary-500 dark:hover:bg-opacity-30 active:bg-primary-200 dark:active:bg-primary-500 dark:active:bg-opacity-40",
        plain: "bg-transparent border border-transparent text-gray-600 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-600 active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500",
        danger: "bg-red-600 text-white hover:bg-red-500 active:bg-red-700"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button = React73.forwardRef(
  ({
    className,
    icon,
    endIcon,
    loading,
    children: providedChildren,
    variant,
    size,
    asChild = false,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    const renderChildren = () => {
      if (loading && providedChildren) {
        return /* @__PURE__ */ React73.createElement("span", { className: "flex items-center justify-center" }, /* @__PURE__ */ React73.createElement(Spinner, { enableTheme: false, className: "mr-1" }), providedChildren, endIcon);
      }
      if (icon && !providedChildren && loading) {
        return /* @__PURE__ */ React73.createElement(Spinner, { enableTheme: false });
      }
      if (icon && !providedChildren && !loading) {
        return /* @__PURE__ */ React73.createElement(React73.Fragment, null, icon);
      }
      if ((icon || endIcon) && providedChildren && !loading) {
        return /* @__PURE__ */ React73.createElement("span", { className: "flex items-center justify-center gap-2" }, icon && /* @__PURE__ */ React73.createElement("span", { className: "text-lg" }, icon), /* @__PURE__ */ React73.createElement("span", { className: "ltr:ml-1 rtl:mr-1" }, providedChildren), endIcon);
      }
      return /* @__PURE__ */ React73.createElement(React73.Fragment, null, providedChildren);
    };
    return /* @__PURE__ */ React73.createElement(Comp, { className: cn(buttonVariants({ variant, size, className })), ref, ...props }, renderChildren());
  }
);
Button.displayName = "Button";
var Card = React73.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref,
      className: cn("rounded-lg border bg-card text-card-foreground shadow-sm", className),
      ...props
    }
  )
);
Card.displayName = "Card";
var CardHeader = React73.forwardRef(
  ({ className, children, bordered, extra, ...props }, ref) => /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref,
      className: cn(
        "flex flex-col space-y-1.5 py-3 px-5",
        bordered && "border-b border-gray-200 dark:border-gray-600",
        extra && "flex-row justify-between items-center",
        className
      ),
      ...props
    },
    children,
    extra && /* @__PURE__ */ React73.createElement("div", null, extra)
  )
);
CardHeader.displayName = "CardHeader";
var CardTitle = React73.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
    "h3",
    {
      ref,
      className: cn("text-2xl font-semibold leading-none tracking-tight", className),
      ...props
    }
  )
);
CardTitle.displayName = "CardTitle";
var CardDescription = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("p", { ref, className: cn("text-sm text-muted-foreground", className), ...props }));
CardDescription.displayName = "CardDescription";
var CardContent = React73.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("div", { ref, className: cn("p-5", className), ...props })
);
CardContent.displayName = "CardContent";
var CardFooter = React73.forwardRef(
  ({ className, bordered, ...props }, ref) => /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref,
      className: cn(
        "flex items-center py-3 px-5",
        bordered && "border-t border-gray-200 dark:border-gray-600",
        className
      ),
      ...props
    }
  )
);
CardFooter.displayName = "CardFooter";
function Calendar({ className, classNames: classNames3, showOutsideDays = true, ...props }) {
  return /* @__PURE__ */ React73.createElement(
    DayPicker,
    {
      showOutsideDays,
      className: cn("p-3", className),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...classNames3
      },
      components: {
        IconLeft: ({ ...props2 }) => /* @__PURE__ */ React73.createElement(FiChevronLeft, { className: "h-4 w-4" }),
        IconRight: ({ ...props2 }) => /* @__PURE__ */ React73.createElement(FiChevronRight, { className: "h-4 w-4" })
      },
      ...props
    }
  );
}
Calendar.displayName = "Calendar";

// src/utils/constant.ts
var SIZES = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg"
};
var heightBySize = {
  [SIZES.XS]: "h-7",
  [SIZES.SM]: "h-9",
  [SIZES.MD]: "h-11",
  [SIZES.LG]: "h-14"
};
var widthBySize = {
  [SIZES.XS]: "w-7",
  [SIZES.SM]: "w-9",
  [SIZES.MD]: "w-11",
  [SIZES.LG]: "w-14"
};
var LAYOUT = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  INLINE: "inline"
};
var createNamedContext = (defaultValue, displayName) => {
  const Context = React73.createContext(defaultValue);
  Context.displayName = displayName;
  return Context;
};

// src/context/config.ts
var ConfigContext = createNamedContext(
  {
    direction: "ltr",
    mode: "light",
    locale: "en",
    cardBordered: false,
    controlSize: SIZES.MD,
    navMode: "light"
  },
  "ConfigContext"
);
var ConfigProvider = ConfigContext.Provider;
var useConfig = () => React73.useContext(ConfigContext);
var FormStyleContext = createNamedContext(
  {
    labelWidth: 100,
    layout: LAYOUT.VERTICAL,
    size: SIZES.MD
  },
  "FormStyleContext"
);
FormStyleContext.Provider;
var useFormStyle = () => React73.useContext(FormStyleContext);
var InputStyleContext = createNamedContext({}, "InputStyleContext");
InputStyleContext.Provider;
var useInputStyle = () => React73.useContext(InputStyleContext);

// src/context/use-form-control.ts
var DEFAULT = {
  inputId: "",
  status: void 0,
  layout: "horizontal"
};
var FormControlContext = React73.createContext(DEFAULT);
FormControlContext.displayName = "FormControlContext";
var FormControlContextProvider = FormControlContext.Provider;
var useFormControl = () => React73.useContext(FormControlContext);
var useFormControlSize = (providedSize) => {
  const config = useConfig();
  const formStyleSize = useFormStyle().size;
  const inputGroupSize = useInputStyle().size;
  return providedSize || inputGroupSize || formStyleSize || config.controlSize;
};
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverContent = React73.forwardRef(({ className, align = "center", sideOffset = 4, side, ...props }, ref) => /* @__PURE__ */ React73.createElement(PopoverPrimitive.Portal, null, /* @__PURE__ */ React73.createElement(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    side,
    className: cn(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
)));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/components/ui/date-range-picker.tsx
var DateRangePicker = React73.forwardRef(
  ({ value, onValue, className, size, ...props }, forwardedRef) => {
    const [open, setOpen] = React73.useState(false);
    const [hasAutoClosed, setHasAutoClosed] = React73.useState(false);
    const inputSize = useFormControlSize(size || "sm");
    return /* @__PURE__ */ React73.createElement("div", { className: cn("grid gap-2", className) }, /* @__PURE__ */ React73.createElement(Popover, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(PopoverTrigger, { asChild: true }, /* @__PURE__ */ React73.createElement(
      Button,
      {
        id: props.id,
        variant: "outline",
        className: cn(
          "justify-start text-left font-normal",
          "border border-gray-300",
          open && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
          inputSize === "md" && "py-2",
          inputSize === "lg" && "text-lg",
          heightBySize[inputSize],
          !value && "text-muted-foreground"
        ),
        ref: forwardedRef
      },
      /* @__PURE__ */ React73.createElement(FiCalendar, { className: "mr-2 h-4 w-4" }),
      value?.from ? value.to ? /* @__PURE__ */ React73.createElement(React73.Fragment, null, format(value.from, "LLL dd, y"), " - ", format(value.to, "LLL dd, y")) : format(value.from, "LLL dd, y") : /* @__PURE__ */ React73.createElement("span", null, "Pick a date range")
    )), /* @__PURE__ */ React73.createElement(PopoverContent, { className: "w-auto p-0", align: "end" }, /* @__PURE__ */ React73.createElement(
      Calendar,
      {
        initialFocus: true,
        mode: "range",
        defaultMonth: value?.from,
        selected: value,
        onSelect: (newRange) => {
          onValue(newRange);
          if (!hasAutoClosed && value && !value.to && newRange && newRange.to) {
            setHasAutoClosed(true);
            setOpen(false);
          }
        },
        numberOfMonths: 2,
        ...props
      }
    ))));
  }
);
var DatePicker = React73.forwardRef(
  ({ value, onValue, className, size, side, ...props }, forwardedRef) => {
    const [open, setOpen] = React73.useState(false);
    const inputSize = useFormControlSize(size || "sm");
    return /* @__PURE__ */ React73.createElement(Popover, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(PopoverTrigger, { asChild: true }, /* @__PURE__ */ React73.createElement(
      Button,
      {
        id: props.id,
        variant: "outline",
        className: cn(
          "justify-start text-left font-normal",
          "border border-gray-300",
          open && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
          inputSize === "md" && "py-2",
          inputSize === "lg" && "text-lg",
          heightBySize[inputSize],
          !value && "text-muted-foreground"
        ),
        ref: forwardedRef
      },
      /* @__PURE__ */ React73.createElement(FiCalendar, { className: "mr-2 h-4 w-4" }),
      value ? format(value, "PPP") : /* @__PURE__ */ React73.createElement("span", null, "Pick a date")
    )), /* @__PURE__ */ React73.createElement(PopoverContent, { className: "w-auto p-0", side }, /* @__PURE__ */ React73.createElement(
      Calendar,
      {
        mode: "single",
        selected: value && new Date(value),
        defaultMonth: value,
        onSelect: (value2) => {
          onValue(value2);
          setOpen(false);
        },
        ...props,
        initialFocus: true
      }
    )));
  }
);
var Input = React73.forwardRef(
  ({ className, type, inputSize, hideArrows, ...props }, ref) => {
    const sizeFromProps = useFormControlSize(inputSize || "sm");
    return /* @__PURE__ */ React73.createElement(
      "input",
      {
        type,
        className: cn(
          "flex w-full rounded-md border border-gray-300 border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          "focus:outline-none focus:ring-2 focus:border-primary-600 focus:ring-primary-500 focus:ring-opacity-50",
          heightBySize[sizeFromProps],
          hideArrows && "[&::-webkit-inner-spin-button]:appearance-none",
          className
        ),
        ref,
        ...props
      }
    );
  }
);
Input.displayName = "Input";
var Select = SelectPrimitive.Root;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = React73.forwardRef(({ className, children, noBorder, disabled, size, open, ...props }, ref) => {
  const selectSize = useFormControlSize(size || "sm");
  return /* @__PURE__ */ React73.createElement(
    SelectPrimitive.Trigger,
    {
      ref,
      className: cn(
        "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
        !noBorder && "border border-gray-300",
        selectSize === "lg" && "text-lg",
        heightBySize[selectSize],
        open && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
        "focus:outline-none focus:ring-2 focus:border-primary-600 focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50",
        "data-[placeholder]:text-gray-400",
        disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white",
        className
      ),
      disabled,
      ...props
    },
    children,
    /* @__PURE__ */ React73.createElement(SelectPrimitive.Icon, { asChild: true }, /* @__PURE__ */ React73.createElement(FiChevronDown, { className: "h-4 w-4 opacity-50" }))
  );
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectScrollUpButton = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  SelectPrimitive.ScrollUpButton,
  {
    ref,
    className: cn("flex cursor-default items-center justify-center py-1", className),
    ...props
  },
  /* @__PURE__ */ React73.createElement(FiChevronUp, { className: "h-4 w-4" })
));
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
var SelectScrollDownButton = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  SelectPrimitive.ScrollDownButton,
  {
    ref,
    className: cn("flex cursor-default items-center justify-center py-1", className),
    ...props
  },
  /* @__PURE__ */ React73.createElement(FiChevronDown, { className: "h-4 w-4" })
));
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
var SelectContent = React73.forwardRef(({ className, children, position = "popper", ...props }, ref) => /* @__PURE__ */ React73.createElement(SelectPrimitive.Portal, null, /* @__PURE__ */ React73.createElement(
  SelectPrimitive.Content,
  {
    ref,
    className: cn(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      className
    ),
    position,
    ...props
  },
  /* @__PURE__ */ React73.createElement(SelectScrollUpButton, null),
  /* @__PURE__ */ React73.createElement(
    SelectPrimitive.Viewport,
    {
      className: cn(
        "p-1",
        position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
      )
    },
    children
  ),
  /* @__PURE__ */ React73.createElement(SelectScrollDownButton, null)
)));
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  SelectPrimitive.Label,
  {
    ref,
    className: cn("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
    ...props
  }
));
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = React73.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  SelectPrimitive.Item,
  {
    ref,
    className: cn(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props
  },
  /* @__PURE__ */ React73.createElement("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center" }, /* @__PURE__ */ React73.createElement(SelectPrimitive.ItemIndicator, null, /* @__PURE__ */ React73.createElement(FiCheck, { className: "h-4 w-4" }))),
  /* @__PURE__ */ React73.createElement(SelectPrimitive.ItemText, null, children)
));
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  SelectPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-muted", className),
    ...props
  }
));
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
var DateTimePicker = React73.forwardRef(
  ({ value, onValue, size, className, ...props }, ref) => {
    const [open, setOpen] = React73.useState(false);
    const [amOpen, setAmOpen] = React73.useState(false);
    const [selectedDate, setSelectedDate] = React73.useState(value);
    const inputSize = useFormControlSize(size || "sm");
    const handleDateSelect = (newDate) => {
      setSelectedDate(newDate);
      if (newDate) {
        const hours = value ? value.getHours() : 0;
        const minutes = value ? value.getMinutes() : 0;
        newDate.setHours(hours);
        newDate.setMinutes(minutes);
        onValue(newDate);
      } else {
        onValue(void 0);
      }
    };
    const handleTimeChange = (value2, type) => {
      if (selectedDate) {
        let hours = selectedDate.getHours();
        let minutes = selectedDate.getMinutes();
        if (type === "hours") {
          hours = parseInt(value2) % 12;
          if (selectedDate.getHours() >= 12) hours += 12;
        } else if (type === "minutes") {
          minutes = parseInt(value2);
        } else if (type === "ampm") {
          const isPM = value2 === "PM";
          hours = hours % 12 + (isPM ? 12 : 0);
        }
        const newDate = set(selectedDate, { hours, minutes });
        setSelectedDate(newDate);
        onValue(newDate);
      }
    };
    return /* @__PURE__ */ React73.createElement(Popover, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(PopoverTrigger, { asChild: true }, /* @__PURE__ */ React73.createElement(
      Button,
      {
        ref,
        variant: "outline",
        className: cn(
          "justify-start text-left font-normal",
          "border border-gray-300",
          open && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
          inputSize === "md" && "py-2",
          inputSize === "lg" && "text-lg",
          heightBySize[inputSize],
          !value && "text-muted-foreground",
          className
        )
      },
      /* @__PURE__ */ React73.createElement(FiCalendar, { className: "mr-2 h-4 w-4" }),
      value ? format(value, "PPP p") : /* @__PURE__ */ React73.createElement("span", null, "Pick a date and time")
    )), /* @__PURE__ */ React73.createElement(PopoverContent, { className: "w-auto p-0" }, /* @__PURE__ */ React73.createElement(
      Calendar,
      {
        className: "w-full",
        mode: "single",
        selected: selectedDate,
        onSelect: handleDateSelect,
        initialFocus: true,
        ...props
      }
    ), /* @__PURE__ */ React73.createElement("div", { className: "border-t p-3 space-y-2" }, /* @__PURE__ */ React73.createElement("div", { className: "flex items-center space-x-2" }, /* @__PURE__ */ React73.createElement(FiClock, { className: "h-4 w-4 text-muted-foreground" }), /* @__PURE__ */ React73.createElement(
      Input,
      {
        type: "number",
        min: 1,
        max: 12,
        className: "w-[50px]",
        placeholder: "hh",
        value: selectedDate ? format(selectedDate, "h") : "",
        onChange: (e) => handleTimeChange(e.target.value, "hours"),
        hideArrows: true
      }
    ), /* @__PURE__ */ React73.createElement("span", null, ":"), /* @__PURE__ */ React73.createElement(
      Input,
      {
        type: "number",
        min: 0,
        max: 59,
        className: "w-[50px]",
        placeholder: "mm",
        value: selectedDate ? format(selectedDate, "mm") : "",
        onChange: (e) => handleTimeChange(e.target.value, "minutes"),
        hideArrows: true
      }
    ), /* @__PURE__ */ React73.createElement(
      Select,
      {
        open: amOpen,
        onOpenChange: setAmOpen,
        value: selectedDate ? selectedDate.getHours() >= 12 ? "PM" : "AM" : void 0,
        onValueChange: (value2) => handleTimeChange(value2, "ampm")
      },
      /* @__PURE__ */ React73.createElement(SelectTrigger, { open: amOpen, className: "w-[90px]" }, /* @__PURE__ */ React73.createElement(SelectValue, { placeholder: "AM/PM" })),
      /* @__PURE__ */ React73.createElement(SelectContent, null, /* @__PURE__ */ React73.createElement(SelectItem, { value: "AM" }, "AM"), /* @__PURE__ */ React73.createElement(SelectItem, { value: "PM" }, "PM"))
    )))));
  }
);
DateTimePicker.displayName = "DateTimePicker";
var Checkbox = React73.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ React73.createElement(
      Primitive2.Root,
      {
        ...props,
        className: clsx(
          "group flex justify-center items-center w-6 h-6 border border-gray-300 rounded-md",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          props.disabled && "bg-gray-100 cursor-not-allowed",
          props.className
        ),
        ref: forwardedRef
      },
      /* @__PURE__ */ React73.createElement(Primitive2.CheckboxIndicator, null, /* @__PURE__ */ React73.createElement(HiCheck, { className: "text-primary-600 group-[[data-disabled]]:text-gray-400 group-[[data-state=indeterminate]]:hidden" }), /* @__PURE__ */ React73.createElement(HiMinus, { className: "text-primary-600 group-[[data-disabled]]:text-gray-400 hidden group-[[data-state=indeterminate]]:block" }))
    );
  }
);
var CheckboxGroup = React73.forwardRef(
  function CheckboxGroup2(props, forwardedRef) {
    const { inputId } = useFormControl();
    const fallbackId = React73.useId();
    const { value = [] } = props;
    const { orientation = "vertical", id = inputId || fallbackId } = props;
    return /* @__PURE__ */ React73.createElement(
      "div",
      {
        className: clsx(
          "flex gap-3",
          {
            vertical: "flex-col",
            horizontal: "flex-row"
          }[orientation],
          props.className
        )
      },
      props.options.map((option, index) => /* @__PURE__ */ React73.createElement("div", { className: "flex items-center gap-3", key: index }, /* @__PURE__ */ React73.createElement(
        Checkbox,
        {
          id: `${id}-${index}`,
          value: option.value,
          name: props.name,
          disabled: props.disabled,
          checked: value.includes(option.value),
          onCheckedChange: () => {
            if (props.onValue) {
              props.onValue(
                value.includes(option.value) ? value.filter((v) => v !== option.value) : value.concat(option.value)
              );
            }
          },
          ref: index === 0 ? forwardedRef : void 0
        }
      ), /* @__PURE__ */ React73.createElement(
        "label",
        {
          htmlFor: `${id}-${index}`,
          className: clsx("text-sm select-none", option.displayLabel && "sr-only")
        },
        option.label
      ), option.displayLabel && /* @__PURE__ */ React73.createElement("div", { "aria-hidden": true }, option.displayLabel)))
    );
  }
);
var FieldGroup = ({
  children,
  fieldId,
  status,
  layout = "responsive",
  ...props
}) => {
  const reactId = React73.useId();
  const content = /* @__PURE__ */ React73.createElement(
    FormControlContextProvider,
    {
      value: React73.useMemo(
        () => ({
          inputId: fieldId || reactId,
          status,
          layout
        }),
        [fieldId, status, layout]
      )
    },
    children
  );
  return /* @__PURE__ */ React73.createElement("div", { ...props, className: clsx(classByLayout[layout], props.className) }, layout === "responsive" ? /* @__PURE__ */ React73.createElement(
    "div",
    {
      className: clsx(
        classByLayout.vertical,
        "@lg/field:flex-row @lg/field:items-center @lg/field:gap-3"
      )
    },
    content
  ) : content);
};
var classByLayout = {
  horizontal: "flex items-center gap-3",
  vertical: "flex flex-col gap-1",
  responsive: "@container/field"
};
var Label2 = ({ children, showRequiredIndicator, ...props }) => {
  const { inputId, status, layout } = useFormControl();
  return /* @__PURE__ */ React73.createElement(
    "label",
    {
      ...props,
      htmlFor: props.htmlFor || inputId,
      className: clsx(
        "flex items-center text-sm",
        layout === "horizontal" && "w-36 flex-shrink-0",
        layout === "responsive" && "@lg/field:w-36 @md/field:flex-shrink-0",
        status === "danger" ? "text-red-500" : "text-gray-600",
        props.className
      )
    },
    children,
    showRequiredIndicator && /* @__PURE__ */ React73.createElement("span", { className: "text-red-700" }, "*")
  );
};

// src/components/checkbox-field.tsx
var CheckboxField = React73.forwardRef(
  function CheckboxField2({ id, status, label, layout, required, ...props }, forwardedRef) {
    const fallbackId = React73.useId();
    const ensuredId = id || fallbackId;
    const labelId = `${ensuredId}__label`;
    return /* @__PURE__ */ React73.createElement(
      FieldGroup,
      {
        fieldId: ensuredId,
        status,
        layout,
        role: "group",
        "aria-labelledby": labelId
      },
      label && /* @__PURE__ */ React73.createElement(Label2, { className: "self-start", id: labelId, showRequiredIndicator: required }, label),
      /* @__PURE__ */ React73.createElement(CheckboxGroup, { ...props, ref: forwardedRef })
    );
  }
);
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger2 = CollapsiblePrimitive.CollapsibleTrigger;
var CollapsibleContent2 = CollapsiblePrimitive.CollapsibleContent;
var DateRangeField = React73.forwardRef(
  function DateRangeField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(DateRangePicker, { ...props, ref: forwardedRef }));
  }
);

// src/utils/type-guard.ts
var isDefined = (value) => typeof value !== "undefined";
var isNil = (value) => value == null;
var isString = (value) => typeof value === "string";
var isNumber = (value) => typeof value === "number";
var isFunction = (value) => typeof value === "function";
var isObject = (value) => !isNil(value) && typeof value === "object";
var isPrimitive = (value) => /^(b|st|n)/.test(typeof value);

// src/utils/date.ts
var formatDate = (date, {
  formatType = "dateOnly",
  format: format4 = formatType === "dateOnly" ? FORMAT_STRING.dayOnly : FORMAT_STRING.dayAndTime
} = {}) => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return isNaN(dateObj.getTime()) ? date : format(dateObj, format4);
};
var formatDateUtc = (date) => {
  const d = typeof date === "string" ? new Date(date) : date;
  return format(addMinutes(d, d.getTimezoneOffset()), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
};
var formatDateRange = (dateRange, dayOnly) => {
  const { from, to } = dateRange;
  if (isDefined(from)) {
    const fromDisplay = formatDate(from, { formatType: dayOnly ? "dateOnly" : "dateAndTime" });
    if (!isDefined(to)) {
      return `from ${fromDisplay}`;
    }
    if (isSameDay(from, to)) {
      const dayOnlyDisplay = formatDate(from, { formatType: "dateOnly" });
      if (dayOnly) {
        return dayOnlyDisplay;
      }
      const fromTime = format(from, FORMAT_STRING.timeOnly);
      const toTime = format(to, FORMAT_STRING.timeOnly);
      if (fromTime === toTime) {
        return formatDate(from, { formatType: "dateAndTime" });
      }
      return `${dayOnlyDisplay}, ${fromTime} - ${toTime}`;
    } else {
      const toDisplay = formatDate(to, { formatType: dayOnly ? "dateOnly" : "dateAndTime" });
      return `${fromDisplay} - ${toDisplay}`;
    }
  }
  return "";
};
var FORMAT_STRING = {
  dayOnly: "d MMM yyyy",
  dayAndTime: "d MMM yyyy, h:mm a",
  timeOnly: "h:mm a"
};
var cssHooks = {
  today: "data__day-today",
  selected: "data__day-selected"
};
var DayPicker2 = (props) => /* @__PURE__ */ React73.createElement(DayPicker, { classNames: classNames2, ...props });
var classNames2 = {
  vhidden: "sr-only",
  caption: "flex justify-center items-center h-10",
  root: "inline-block text-gray-800",
  months: "flex gap-4 relative px-4",
  caption_label: "inline-flex items-center gap-2 text-base px-1",
  caption_dropdowns: "flex flex-row-reverse justify-between gap-4 w-full px-2",
  dropdown_month: "relative inline-flex items-center",
  dropdown: "absolute inset-0 opacity-0 z-10",
  dropdown_year: "relative inline-flex items-center",
  nav_button: "inline-flex justify-center items-center absolute top-0 w-10 h-10 rounded-full text-gray-600 hover:bg-gray-100",
  nav_button_next: "right-0",
  nav_button_previous: "left-0",
  table: "border-collapse border-spacing-0",
  head_cell: "w-10 h-10 text-sm uppercase align-middle text-center",
  cell: "w-10 h-10 align-middle text-center border-0 px-0",
  day: "inline-flex justify-center items-center w-10 h-10 rounded-full transition-colors hover:bg-primary-100 hover:text-gray-800 focus:outline-none focus-visible:ring focus-visible:ring-primary-300 focus-visible:ring-opacity-50 active:bg-primary-500 active:text-white",
  day_selected: `${cssHooks.selected} text-white bg-primary-500 hover:text-white hover:bg-primary-800`,
  day_today: `${cssHooks.today} font-bold`,
  day_disabled: "opacity-25 hover:bg-white active:bg-white active:text-gray-800",
  day_outside: "enabled:opacity-50",
  day_range_middle: "rounded-none",
  day_range_end: "rounded-l-none rounded-r-full",
  day_range_start: "rounded-r-none rounded-l-full",
  day_hidden: "hidden"
};
var InputButton = React73.forwardRef(
  function InputButton2({ size, className, appearFocus, appearEmpty, ...props }, forwardedRef) {
    const inputSize = useFormControlSize(size);
    return /* @__PURE__ */ React73.createElement(
      "button",
      {
        type: "button",
        className: clsx(
          "flex items-center w-full px-3 text-left border border-gray-300 rounded-md",
          inputSize === "md" && "py-2",
          inputSize === "lg" && "text-lg",
          heightBySize[inputSize],
          appearFocus && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
          appearEmpty && "text-gray-400",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          props.disabled && "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70",
          className
        ),
        ...props,
        ref: forwardedRef
      }
    );
  }
);
var Content5 = React73.forwardRef(
  function PopoverContent2(props, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      PopoverPrimitive.Content,
      {
        style: {
          transformOrigin: "var(--radix-popover-content-transform-origin)"
        },
        ...props,
        className: clsx(
          "p-1 bg-white rounded shadow-lg animate-[scalein_100ms_ease-out]",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Popover2 = Object.assign({}, PopoverPrimitive, { Content: Content5 });

// src/components/date-range-selector.tsx
var DateRangeSelector = React73.forwardRef(
  function DateRangeSelector2({ name, id, placeholder = "Select date", value, onValue, disabled, size, required, ...props }, forwardedRef) {
    const [open, setOpen] = React73.useState(false);
    const valueString = React73.useMemo(() => value ? formatDateRange(value, true) : "", [value]);
    const contentRef = React73.useRef(null);
    const { inputId } = useFormControl();
    const [hasAutoClosed, setHasAutoClosed] = React73.useState(false);
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement("input", { type: "hidden", value: valueString, name, required }), /* @__PURE__ */ React73.createElement(Popover2.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(Popover2.Trigger, { asChild: true }, /* @__PURE__ */ React73.createElement(
      InputButton,
      {
        id: id || inputId,
        size,
        appearFocus: open,
        appearEmpty: !value || !value.from,
        disabled,
        ref: forwardedRef
      },
      valueString || placeholder
    )), /* @__PURE__ */ React73.createElement(Popover2.Portal, null, /* @__PURE__ */ React73.createElement(
      Popover2.Content,
      {
        align: "start",
        sideOffset: 2,
        onOpenAutoFocus: (ev) => {
          ev.preventDefault();
          if (contentRef.current) {
            const selected = contentRef.current.querySelector(`.${cssHooks.selected}`);
            const target = selected || contentRef.current.querySelector(`.${cssHooks.today}`);
            if (target && target instanceof HTMLElement) {
              target.focus();
            }
          }
        },
        ref: contentRef
      },
      /* @__PURE__ */ React73.createElement(
        DayPicker2,
        {
          mode: "range",
          selected: value,
          onSelect: (newRange) => {
            onValue(newRange);
            if (!hasAutoClosed && value && !value.to && newRange && newRange.to) {
              setHasAutoClosed(true);
              setOpen(false);
            }
          },
          ...props
        }
      )
    ))));
  }
);
var DateTimeField = React73.forwardRef(
  function DateTimeField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(DateTimePicker, { ...props, ref: forwardedRef }));
  }
);
var DaySelector = React73.forwardRef(
  function DaySelector2({
    name,
    id,
    placeholder = "Select date",
    value,
    onValue,
    disabled,
    min,
    max,
    size,
    monthNavigation = "buttons",
    fromYear = monthNavigation === "dropdown" ? min ? min.getFullYear() : 1960 : void 0,
    toYear = monthNavigation === "dropdown" ? max ? max.getFullYear() : 2050 : void 0,
    className,
    ...props
  }, forwardedRef) {
    const [open, setOpen] = React73.useState(false);
    const valueString = React73.useMemo(() => value ? formatDate(value) : "", [value]);
    const contentRef = React73.useRef(null);
    const computedDisabled = React73.useMemo(() => {
      const result = [];
      if (min) {
        result.push({
          before: min
        });
      }
      if (max) {
        result.push({
          after: max
        });
      }
      return result;
    }, [min, max]);
    const { inputId } = useFormControl();
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement("input", { type: "hidden", value: valueString, name, required: props.required }), /* @__PURE__ */ React73.createElement(Popover2.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(Popover2.Trigger, { asChild: true }, /* @__PURE__ */ React73.createElement(
      InputButton,
      {
        id: id || inputId,
        ref: forwardedRef,
        appearFocus: open,
        appearEmpty: !value,
        disabled,
        size,
        className
      },
      valueString || placeholder
    )), /* @__PURE__ */ React73.createElement(Popover2.Portal, null, /* @__PURE__ */ React73.createElement(
      Popover2.Content,
      {
        align: "start",
        sideOffset: 2,
        onOpenAutoFocus: (ev) => {
          ev.preventDefault();
          if (contentRef.current) {
            const selected = contentRef.current.querySelector(`.${cssHooks.selected}`);
            const target = selected || contentRef.current.querySelector(`.${cssHooks.today}`);
            if (target && target instanceof HTMLElement) {
              target.focus();
            }
          }
        },
        ref: contentRef
      },
      /* @__PURE__ */ React73.createElement(
        DayPicker2,
        {
          mode: "single",
          selected: value,
          onSelect: (val) => {
            onValue(val);
            setOpen(false);
          },
          disabled: computedDisabled,
          captionLayout: monthNavigation,
          fromYear,
          toYear,
          ...props
        }
      )
    ))));
  }
);

// src/utils/fn-lib.ts
function callAll(...fns) {
  return function callAllFns() {
    const arg = arguments;
    fns.forEach((fn) => typeof fn === "function" && fn.apply(null, arg));
  };
}

// src/utils/feature-check.ts
var featureCheck = {
  stringRepeat: !!String.prototype.repeat,
  stringPadStart: !!String.prototype.padStart,
  stringPadEnd: !!String.prototype.padEnd,
  intlNumberFormat: !!(typeof Intl === "object" && Intl && typeof Intl.NumberFormat === "function"),
  intListFormat: !!(typeof Intl === "object" && Intl && typeof Intl.ListFormat === "function")
};

// src/utils/string.ts
var stringRepeat = (charToRepeat, count) => {
  if (featureCheck.stringRepeat) {
    return charToRepeat.repeat(count);
  }
  if (count < 0 || count === Infinity) {
    throw RangeError(`Repeat count must be between 0 and Infinity`);
  }
  let result = "";
  for (let index = 0; index < count; index++) {
    result += charToRepeat;
  }
  return result;
};
var padStart = (oriString, maxLength, fillString = " ") => {
  if (featureCheck.stringPadStart) {
    return oriString.padStart(maxLength, fillString);
  }
  const requiredPadding = maxLength - oriString.length;
  if (requiredPadding <= 0) {
    return oriString;
  }
  return stringRepeat(fillString, requiredPadding) + oriString;
};
var padEnd = (oriString, maxLength, fillString = " ") => {
  if (featureCheck.stringPadEnd) {
    return oriString.padEnd(maxLength, fillString);
  }
  const requiredPadding = maxLength - oriString.length;
  if (requiredPadding <= 0) {
    return oriString;
  }
  return oriString + stringRepeat(fillString, requiredPadding);
};
var forwardRefWithGenerics = forwardRef;

// src/components/select.tsx
var Select2 = forwardRefWithGenerics(function Select3({
  options,
  size,
  placeholder,
  disabled,
  value,
  onValue,
  id,
  className,
  noBorder,
  ...selectProps
}, forwardedRef) {
  const selectSize = useFormControlSize(size);
  const { inputId } = useFormControl();
  const normalizedValue = isNumber(value) ? String(value) : value;
  const normalizedOptions = options.map((option) => ({
    ...option,
    domValue: String(option.value)
  }));
  return /* @__PURE__ */ React73.createElement(
    SelectPrimitive.Root,
    {
      ...selectProps,
      value: normalizedValue,
      onValueChange: (value2) => {
        if (onValue) {
          const matchedOption = normalizedOptions.find((opt) => opt.domValue === value2);
          if (matchedOption) {
            onValue(matchedOption.value);
          } else {
            onValue(value2);
          }
        }
      }
    },
    /* @__PURE__ */ React73.createElement(
      SelectPrimitive.Trigger,
      {
        className: clsx(
          "flex justify-between items-center w-full rounded-md",
          !noBorder && "border border-gray-300",
          selectSize === "lg" && "text-lg",
          heightBySize[selectSize],
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          "data-[placeholder]:text-gray-400",
          disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white",
          className
        ),
        id: id || inputId,
        disabled,
        ref: forwardedRef
      },
      /* @__PURE__ */ React73.createElement("span", { className: "block px-3 py-2" }, /* @__PURE__ */ React73.createElement(SelectPrimitive.Value, { placeholder })),
      /* @__PURE__ */ React73.createElement("span", { className: "p-2 text-xl" }, /* @__PURE__ */ React73.createElement(SelectPrimitive.Icon, { asChild: true }, /* @__PURE__ */ React73.createElement("span", null, /* @__PURE__ */ React73.createElement(HiChevronDown, { className: "text-gray-400", width: 20, height: 20 }))))
    ),
    /* @__PURE__ */ React73.createElement(SelectPrimitive.Portal, null, /* @__PURE__ */ React73.createElement(SelectPrimitive.Content, { className: "z-50 bg-white border border-gray-50 shadow-lg rounded" }, /* @__PURE__ */ React73.createElement(SelectPrimitive.ScrollUpButton, null, /* @__PURE__ */ React73.createElement(HiChevronUp, null)), /* @__PURE__ */ React73.createElement(SelectPrimitive.Viewport, null, normalizedOptions.map((option, index) => /* @__PURE__ */ React73.createElement(
      SelectPrimitive.Item,
      {
        className: clsx(
          "flex justify-between items-center px-2 py-1.5 data-[state=checked]:bg-gray-100",
          "data-[highlighted]:bg-gray-50 data-[highlighted]:outline-none"
        ),
        value: option.domValue,
        key: index
      },
      /* @__PURE__ */ React73.createElement(SelectPrimitive.ItemText, null, option.label),
      /* @__PURE__ */ React73.createElement(SelectPrimitive.ItemIndicator, null, /* @__PURE__ */ React73.createElement(HiCheck, { className: "text-primary-600" }))
    )), /* @__PURE__ */ React73.createElement(SelectPrimitive.ScrollDownButton, null, /* @__PURE__ */ React73.createElement(HiChevronDown, null)))))
  );
});
var TextInput = React73.forwardRef(function TextInput2({ className, prefix, size, suffix, style, onValue, onChange, noBorder, ...inputProps }, ref) {
  const [prefixGutter, setPrefixGutter] = React73.useState(0);
  const [suffixGutter, setSuffixGutter] = React73.useState(0);
  const { direction } = useConfig();
  const inputSize = useFormControlSize(size);
  const { inputId } = useFormControl();
  const prefixNode = React73.useRef(null);
  const suffixNode = React73.useRef(null);
  const getAffixSize = () => {
    if (!prefixNode.current && !suffixNode.current) {
      return;
    }
    const prefixNodeWidth = prefixNode?.current?.offsetWidth;
    const suffixNodeWidth = suffixNode?.current?.offsetWidth;
    if (isNil(prefixNodeWidth) && isNil(suffixNodeWidth)) {
      return;
    }
    if (prefixNodeWidth) {
      setPrefixGutter(prefixNodeWidth);
    }
    if (suffixNodeWidth) {
      setSuffixGutter(suffixNodeWidth);
    }
  };
  React73.useEffect(() => {
    getAffixSize();
  }, [prefix, suffix]);
  const affixGutterStyle = () => {
    const leftGutter = `${remToPxConvertion(prefixGutter) + 1}rem`;
    const rightGutter = `${remToPxConvertion(suffixGutter) + 1}rem`;
    const gutterStyle = {};
    if (direction === "ltr") {
      if (prefix) {
        gutterStyle.paddingLeft = leftGutter;
      }
      if (suffix) {
        gutterStyle.paddingRight = rightGutter;
      }
    }
    if (direction === "rtl") {
      if (prefix) {
        gutterStyle.paddingRight = leftGutter;
      }
      if (suffix) {
        gutterStyle.paddingLeft = rightGutter;
      }
    }
    return gutterStyle;
  };
  const inputNode = /* @__PURE__ */ React73.createElement(
    "input",
    {
      type: inputProps.type ?? "text",
      style: { ...affixGutterStyle(), ...style },
      className: clsx(
        "w-full py-2 px-3 rounded-md",
        !noBorder && "border border-gray-300",
        inputSize === "lg" && "text-lg",
        heightBySize[inputSize],
        "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
        !prefix && !suffix ? className : "",
        inputProps.disabled && "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70"
      ),
      ref,
      onChange: callAll(onChange, onValue && ((ev) => onValue(ev.target.value))),
      ...inputProps,
      id: inputProps.id || inputId
    }
  );
  if (prefix || suffix) {
    return /* @__PURE__ */ React73.createElement("div", { className: clsx("relative w-full flex", className) }, prefix ? /* @__PURE__ */ React73.createElement(
      "div",
      {
        className: "absolute top-2/4 transform -translate-y-2/4 left-2.5 rtl:right-2.5",
        ref: prefixNode
      },
      prefix
    ) : null, inputNode, suffix ? /* @__PURE__ */ React73.createElement(
      "div",
      {
        className: "absolute top-2/4 transform -translate-y-2/4 right-2.5 rtl:left-2.5 flex",
        ref: suffixNode
      },
      suffix
    ) : null);
  } else {
    return inputNode;
  }
});
var remToPxConvertion = (pixel) => 0.0625 * pixel;

// src/components/time-input.tsx
var TimeInput = ({
  onValue,
  hours,
  minutes,
  includeSeconds,
  seconds,
  wrapperClass,
  ...props
}) => {
  const isPm = !!hours && hours >= 12;
  const displayedHour = isDefined(hours) ? hours % 12 === 0 ? 12 : isPm ? hours - 12 : hours : hours;
  const displayedValue = React73.useMemo(() => {
    if (!isDefined(displayedHour) && !includeSeconds) {
      return "";
    }
    const valueWithoutSeconds = `${padStart((displayedHour || 0).toString(), 2, "0")}:${padStart(
      (minutes || 0).toString(),
      2,
      "0"
    )}`;
    return includeSeconds ? `${valueWithoutSeconds}:${padStart((seconds || 0).toString(), 2, "0")}` : valueWithoutSeconds;
  }, [displayedHour, minutes, seconds, includeSeconds]);
  const [v, setV] = React73.useState(displayedValue);
  React73.useEffect(() => {
    setV(displayedValue);
  }, [displayedValue]);
  const handleChangeHour = (hours2) => onValue(
    includeSeconds ? {
      hours: hours2,
      minutes: minutes || 0,
      seconds
    } : {
      hours: hours2,
      minutes: minutes || 0
    }
  );
  const rifm = useRifm({
    value: v,
    onChange: setV,
    format: includeSeconds ? formatTimeWithSeconds : formatTime,
    mask: true,
    replace: includeSeconds ? addMaskWithSeconds : addMask
  });
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("inline-flex border border-gray-300 rounded-md", wrapperClass) }, /* @__PURE__ */ React73.createElement("div", { className: "relative flex-1" }, /* @__PURE__ */ React73.createElement(
    "div",
    {
      className: "absolute inset-y-0 left-0 px-1.5 my-1 ml-1 rounded-full flex items-center pointer-events-none",
      "aria-hidden": true
    },
    /* @__PURE__ */ React73.createElement(HiClock, { className: "w-4 h-4 text-gray-400" })
  ), /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      value: rifm.value,
      ...props,
      onChange: callAll(rifm.onChange, props.onChange),
      onBlur: callAll((ev) => {
        const newValue = parseValue(ev.target.value, isPm, includeSeconds);
        if (newValue) {
          if (hours !== newValue.hours || minutes !== newValue.minutes || includeSeconds && seconds !== newValue.seconds) {
            onValue(newValue);
          }
        } else {
          if (isDefined(hours) || isDefined(minutes) || includeSeconds && isDefined(seconds)) {
            onValue(void 0);
          }
        }
      }, props.onBlur),
      className: clsx(
        "pl-8 rounded-r-none",
        includeSeconds ? "w-[119px]" : "w-[105px]",
        props.className
      ),
      noBorder: true
    }
  ), /* @__PURE__ */ React73.createElement("div", { className: "absolute inset-y-0 right-1 flex flex-col" }, /* @__PURE__ */ React73.createElement(
    MiniIconButton,
    {
      onClick: () => handleChangeHour((hours || 0) + 1),
      disabled: props.disabled || hours === 23,
      className: "pt-2 rounded-t-xl"
    },
    /* @__PURE__ */ React73.createElement("span", { className: "sr-only" }, "Increase hour"),
    /* @__PURE__ */ React73.createElement(HiOutlineChevronUp, { className: "text-lightgrey w-3 h-3" })
  ), /* @__PURE__ */ React73.createElement(
    MiniIconButton,
    {
      onClick: () => handleChangeHour((hours || 0) - 1),
      disabled: props.disabled || !hours,
      className: "pb-2 rounded-b-xl"
    },
    /* @__PURE__ */ React73.createElement("span", { className: "sr-only" }, "Decrease hour"),
    /* @__PURE__ */ React73.createElement(HiOutlineChevronUp, { className: "text-lightgrey w-3 h-3 transform rotate-180" })
  ))), /* @__PURE__ */ React73.createElement(
    Select2,
    {
      value: isPm ? "PM" : "AM",
      className: clsx("w-20 rounded-l-none ring-0 border-l border-gray-300"),
      onValue: (value) => handleChangeHour((hours || 0) + (value === "AM" ? -12 : 12)),
      disabled: props.disabled,
      options: amPmOptions,
      noBorder: true,
      size: props.size
    }
  ));
};
var MiniIconButton = (props) => /* @__PURE__ */ React73.createElement(
  "button",
  {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    ...props,
    className: clsx(
      "flex-1 px-2 focus:outline-none",
      !props.disabled && "active:bg-gray-100",
      props.className
    )
  }
);
var amPmOptions = [
  {
    value: "AM",
    label: "AM"
  },
  {
    value: "PM",
    label: "PM"
  }
];
var parseTimeDigits = (value) => (value.match(/^(0[1-9]|1[0-2]):?([0-5][0-9]?)?:?([0-5][0-9]?)?/) || value.match(/^(0|1)/) || []).slice(1).join("");
var formatTime = (value) => {
  const digits = parseTimeDigits(value);
  const chars = digits.split("");
  return chars.reduce((r, v, index) => index === 2 ? `${r}:${v}` : `${r}${v}`, "").substring(0, 5);
};
var formatTimeWithSeconds = (value) => {
  const digits = parseTimeDigits(value);
  const chars = digits.split("");
  return chars.reduce((r, v, index) => index === 2 || index === 4 ? `${r}:${v}` : `${r}${v}`, "").substring(0, 8);
};
var addMask = (value) => {
  const digits = parseTimeDigits(value);
  const hours = padEnd(digits.slice(0, 2), 2, "_");
  const minutes = padEnd(digits.slice(2, 4), 2, "_");
  return `${hours}:${minutes}`;
};
var addMaskWithSeconds = (value) => {
  const digits = parseTimeDigits(value);
  const hours = padEnd(digits.slice(0, 2), 2, "_");
  const minutes = padEnd(digits.slice(2, 4), 2, "_");
  const seconds = padEnd(digits.slice(4, 6), 2, "_");
  return `${hours}:${minutes}:${seconds}`;
};
var parseValue = (value, isPm, includeSeconds) => {
  const digits = parseTimeDigits(value);
  if (!digits) {
    return void 0;
  }
  const parsedHours = Number(padStart(digits.slice(0, 2), 2, "0"));
  const hours = parsedHours > 12 || parsedHours === 0 ? parsedHours : parsedHours === 12 ? isPm ? 12 : 0 : isPm ? 12 + parsedHours : parsedHours;
  const minutes = Number(padStart(digits.slice(2, 4), 2, "0"));
  const seconds = Number(padStart(digits.slice(4, 6), 2, "0"));
  return includeSeconds ? {
    hours,
    minutes,
    seconds
  } : {
    hours,
    minutes
  };
};

// src/components/date-time-input.tsx
var DateTimeInput = React73.forwardRef(
  function DateTimeInput2({ value, onValue, wrapperClass, dayClass, timeClass, includeSeconds, ...dayProps }, forwardedRef) {
    const currentHour = value ? value.getHours() : 0;
    const currentMinute = value ? value.getMinutes() : 0;
    return /* @__PURE__ */ React73.createElement("div", { className: clsx("flex flex-wrap gap-3", wrapperClass) }, /* @__PURE__ */ React73.createElement(
      DaySelector,
      {
        value,
        className: clsx(dayClass, "w-40"),
        onValue: (newDay) => {
          onValue(
            newDay && set(newDay, {
              hours: currentHour,
              minutes: currentMinute
            })
          );
        },
        ...dayProps,
        ref: forwardedRef
      }
    ), /* @__PURE__ */ React73.createElement(
      TimeInput,
      {
        hours: currentHour,
        minutes: currentMinute,
        seconds: includeSeconds ? value ? value.getSeconds() : 0 : void 0,
        disabled: dayProps.disabled || !value,
        onValue: (changes) => onValue(set(value, changes || { hours: 0, minutes: 0, seconds: 0 })),
        className: timeClass,
        includeSeconds
      }
    ));
  }
);
var DateField = React73.forwardRef(function DateField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(DatePicker, { ...props, ref: forwardedRef, size: props.size }));
});
var Skeleton = ({
  width = "narrow",
  height = "short",
  bgClass = "bg-gray-200",
  heightClass = heightClasses[height],
  widthClass = widthClasses[width],
  className,
  ...props
}) => /* @__PURE__ */ React73.createElement("div", { ...props, className: clsx(bgClass, heightClass, widthClass, className) });
var widthClasses = {
  narrow: "w-12",
  medium: "w-32",
  wide: "w-48",
  full: "w-full"
};
var heightClasses = {
  short: "h-4",
  medium: "h-6",
  tall: "h-9"
};

// src/components/desc-list.tsx
var DescContext = createNamedContext(
  {
    isLoading: false,
    itemLayout: "vertical"
  },
  "DescContext"
);
var DescItem = ({ label, value, span, ...props }) => {
  const context = React73.useContext(DescContext);
  const isVertical = context.itemLayout === "vertical";
  return /* @__PURE__ */ React73.createElement(
    "div",
    {
      ...props,
      className: clsx(
        isVertical ? ["block", span === 2 && "@md/desc:col-span-2"] : "flex justify-between items-center py-1 hover:bg-gray-50",
        props.className
      )
    },
    /* @__PURE__ */ React73.createElement("dt", { className: clsx("block text-sm", {
      "text-gray-500": props.highlighted,
      "text-red-500 font-medium": props.highlighted
    }) }, label),
    /* @__PURE__ */ React73.createElement("dd", { className: clsx("block break-words", isVertical && "text-sm", {
      "text-black": !!props.highlighted,
      "text-red-500": !!props.highlighted
    }) }, isNil(value) || value === "" ? context.isLoading ? /* @__PURE__ */ React73.createElement(Skeleton, { heightClass: "h-5", width: "medium" }) : "-" : value)
  );
};
var DescListImpl = function({
  isLoading = false,
  itemLayout = "vertical",
  className,
  ...props
}) {
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("@container/desc", className) }, /* @__PURE__ */ React73.createElement(
    DescContext.Provider,
    {
      value: React73.useMemo(() => ({ isLoading, itemLayout }), [isLoading, itemLayout])
    },
    /* @__PURE__ */ React73.createElement(
      "dl",
      {
        className: clsx(
          "grid",
          itemLayout === "vertical" ? "gap-5 @md/desc:grid-cols-2 @md/desc:gap-x-10" : "gap-3",
          isLoading && "animate-pulse"
        ),
        ...props
      }
    )
  ));
};
var DescList = Object.assign(DescListImpl, { Item: DescItem });
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogClose = DialogPrimitive.Close;
var DialogOverlay = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React73.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ React73.createElement(DialogPortal, null, /* @__PURE__ */ React73.createElement(DialogOverlay, null), /* @__PURE__ */ React73.createElement(
  DialogPrimitive.Content,
  {
    ref,
    className: cn(
      "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
      className
    ),
    ...props
  },
  children,
  /* @__PURE__ */ React73.createElement(DialogPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground" }, /* @__PURE__ */ React73.createElement(FiX, { className: "h-4 w-4" }), /* @__PURE__ */ React73.createElement("span", { className: "sr-only" }, "Close"))
)));
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = ({ className, ...props }) => /* @__PURE__ */ React73.createElement("div", { className: cn("flex flex-col space-y-1.5 text-center sm:text-left", className), ...props });
DialogHeader.displayName = "DialogHeader";
var DialogFooter = ({ className, ...props }) => /* @__PURE__ */ React73.createElement(
  "div",
  {
    className: cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
    ...props
  }
);
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DialogPrimitive.Title,
  {
    ref,
    className: cn("text-lg font-semibold leading-none tracking-tight", className),
    ...props
  }
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DialogPrimitive.Description,
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
DialogDescription.displayName = DialogPrimitive.Description.displayName;
var DialogLeftContent = React73.forwardRef((props, forwardedRef) => /* @__PURE__ */ React73.createElement(
  DialogPrimitive.Content,
  {
    ...props,
    ref: forwardedRef,
    className: cn(
      "fixed bg-white inset-y-0 left-0 animate-[slideinleft_100ms_ease-out]",
      props.className
    )
  }
));
DialogLeftContent.displayName = "DialogLeftContent";
var IconButton = React73.forwardRef(function IconButton2({ type = "button", paddingClass = "p-1", ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(
    "button",
    {
      ...props,
      type,
      className: clsx(
        "text-gray-500 rounded-full focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
        paddingClass,
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var ImageViewer = React73.forwardRef(function ImageViewer2({ file, wrapperClass, alt, src, children, imageRef, ...props }, ref) {
  const [imgSrc, setImgSrc] = React73.useState(src);
  const [currentPage, setCurrentPage] = React73.useState(1);
  const [totalPages, setTotalPages] = React73.useState(0);
  const [pdfDoc, setPdfDoc] = React73.useState(null);
  React73.useEffect(() => {
    if (file) {
      const preview = URL.createObjectURL(file);
      setImgSrc(src || file && preview);
      return () => {
        URL.revokeObjectURL(preview);
      };
    }
  }, [file]);
  React73.useEffect(() => {
    if (!imgSrc?.startsWith("data:application/pdf;base64,")) {
      return;
    }
    const loadPdf = async () => {
      const pdfjsLib = await import('pdfjs-dist');
      pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
        "pdfjs-dist/build/pdf.worker.min.mjs",
        import.meta.url
      ).toString();
      const base64Data = imgSrc.split(",")[1];
      const binaryData = atob(base64Data);
      const array = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        array[i] = binaryData.charCodeAt(i);
      }
      const pdf = await pdfjsLib.getDocument({ data: array }).promise;
      setPdfDoc(pdf);
      setTotalPages(pdf.numPages);
      await renderPage(pdf, 1);
    };
    loadPdf().catch(console.error);
  }, [imgSrc]);
  const renderPage = async (pdf, pageNumber) => {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale: 1 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    await page.render({
      canvasContext: context,
      viewport
    }).promise;
    setImgSrc(canvas.toDataURL());
  };
  const handlePrevPage = async () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      await renderPage(pdfDoc, currentPage - 1);
    }
  };
  const handleNextPage = async () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      await renderPage(pdfDoc, currentPage + 1);
    }
  };
  return imgSrc ? /* @__PURE__ */ React73.createElement("div", { className: clsx("relative inline-block", wrapperClass), ref }, /* @__PURE__ */ React73.createElement("img", { ...props, src: imgSrc, alt: alt || imgSrc.split("/").pop(), ref: imageRef }), children, totalPages > 1 && /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
    "button",
    {
      onClick: (event) => {
        event.preventDefault();
        handlePrevPage();
      },
      disabled: currentPage === 1,
      className: "absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full disabled:opacity-30 disabled:cursor-not-allowed",
      "aria-label": "Previous page"
    },
    "\u2039"
  ), /* @__PURE__ */ React73.createElement(
    "button",
    {
      onClick: (event) => {
        event.preventDefault();
        handleNextPage();
      },
      disabled: currentPage === totalPages,
      className: "absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full disabled:opacity-30 disabled:cursor-not-allowed",
      "aria-label": "Next page"
    },
    "\u203A"
  ), /* @__PURE__ */ React73.createElement("div", { className: "absolute bottom-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-black/50 text-white text-sm rounded" }, currentPage, " / ", totalPages))) : null;
});
var Progress = ({ progress, style = {}, ...divProps }) => /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
  Primitive5.Root,
  {
    ...divProps,
    className: clsx(
      "relative h-1 shadow-inner rounded-lg overflow-hidden bg-gray-300",
      divProps.className
    ),
    value: progress * 100,
    max: 100,
    style: {
      /* Fix overflow clipping in Safari */
      /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
      transform: "translateZ(0)",
      ...style
    }
  },
  /* @__PURE__ */ React73.createElement(
    Primitive5.Indicator,
    {
      className: clsx(
        "w-full h-full bg-primary-500 transition-transform",
        progress >= 1 && "animate-pulse"
      ),
      style: { transform: `translateX(-${(1 - progress) * 100}%)` }
    }
  )
));
var Spinner = ({
  className,
  enableTheme,
  isSpining = true,
  size = 20,
  style,
  ...rest
}) => {
  const spinnerStyle = {
    height: size,
    width: size,
    ...style
  };
  const spinnerClass = clsx(
    isSpining && "animate-spin",
    enableTheme && "text-primary-600",
    className
  );
  const spinnerProps = {
    style: spinnerStyle,
    className: spinnerClass,
    ...rest
  };
  return /* @__PURE__ */ React73.createElement(CgSpinner, { ...spinnerProps });
};

// src/components/file-item.tsx
var FileItem = ({
  file,
  uploadStatus,
  uploadProgress = 0.5,
  onRemove,
  onRetry,
  errorMessage = "Error",
  alt,
  onAltChange,
  className
}) => {
  const isImage = file.type.indexOf("image") === 0;
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("w-80 mx-auto", className) }, /* @__PURE__ */ React73.createElement("div", { className: "text-center" }, isImage ? /* @__PURE__ */ React73.createElement(ImageViewer, { file, className: "max-h-60", alt }) : /* @__PURE__ */ React73.createElement("div", null, file.name)), /* @__PURE__ */ React73.createElement("div", { className: "flex justify-between" }, /* @__PURE__ */ React73.createElement("div", { className: "flex-shrink-0 flex items-center text-sm" }, uploadStatus === "completed" && /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
    HiOutlineCheck,
    {
      className: "w-5 h-5 text-green-500 mr-2 inline-block",
      width: 20,
      height: 20
    }
  ), " ", !onAltChange && /* @__PURE__ */ React73.createElement("span", { className: "text-green-600" }, "Uploaded")), uploadStatus === "error" && /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
    HiOutlineX,
    {
      className: "w-5 h-5 text-red-500 mr-2 inline-block",
      width: 20,
      height: 20
    }
  ), " ", /* @__PURE__ */ React73.createElement("span", { className: "text-red-600" }, errorMessage))), /* @__PURE__ */ React73.createElement("div", { className: "flex-1" }, uploadStatus === "uploading" && /* @__PURE__ */ React73.createElement(Progress, { progress: uploadProgress, className: "w-full" }), uploadStatus === "completed" && onAltChange && /* @__PURE__ */ React73.createElement(TextInput, { value: alt, onValue: onAltChange, size: "sm" })), /* @__PURE__ */ React73.createElement("div", { className: "flex-shrink-0" }, uploadStatus === "error" && /* @__PURE__ */ React73.createElement(IconButton, { onClick: onRetry, "aria-label": "Retry" }, /* @__PURE__ */ React73.createElement(HiOutlineRefresh, { width: 20, height: 20 })), /* @__PURE__ */ React73.createElement(IconButton, { onClick: onRemove, "aria-label": "Remove" }, /* @__PURE__ */ React73.createElement(HiOutlineTrash, { className: "w-5 h-5 text-red-500", width: 20, height: 20 })))));
};
var ImageItem = (props) => {
  const fileInfo = getFileInfo(props.url);
  const alt = props.alt || fileInfo.fileName;
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("w-80 mx-auto", props.className) }, /* @__PURE__ */ React73.createElement("div", { className: "text-center" }, /* @__PURE__ */ React73.createElement(ImageViewer, { src: props.url, className: "max-h-60", alt })), /* @__PURE__ */ React73.createElement("div", { className: "flex justify-between items-center" }, props.onAltChange ? /* @__PURE__ */ React73.createElement("div", { className: "flex-1" }, /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      value: alt,
      onValue: props.onAltChange,
      disabled: props.disabled,
      size: "sm"
    }
  )) : /* @__PURE__ */ React73.createElement("span", { className: "text-sm" }, alt), /* @__PURE__ */ React73.createElement(
    IconButton,
    {
      onClick: props.onRemove,
      disabled: props.disabled || props.isRemoving,
      "aria-label": "Remove"
    },
    props.isRemoving ? /* @__PURE__ */ React73.createElement(Spinner, { className: "w-5 h-5 text-red-500 animate-spin", width: 20, height: 20 }) : /* @__PURE__ */ React73.createElement(HiOutlineTrash, { className: "w-5 h-5 text-red-500", width: 20, height: 20 })
  )));
};
var RemoteFileItem = (props) => {
  const fileInfo = getFileInfo(props.url);
  return fileInfo.isImage ? /* @__PURE__ */ React73.createElement(ImageItem, { ...props }) : /* @__PURE__ */ React73.createElement("div", { className: clsx("w-80 mx-auto", props.className) }, /* @__PURE__ */ React73.createElement("div", { className: "text-center" }, /* @__PURE__ */ React73.createElement("a", { href: props.url, target: "_BLANK", rel: "noreferrer" }, fileInfo.fileName)), /* @__PURE__ */ React73.createElement("div", { className: "text-right" }, /* @__PURE__ */ React73.createElement(
    IconButton,
    {
      onClick: props.onRemove,
      disabled: props.isRemoving || props.disabled,
      "aria-label": "Remove"
    },
    props.isRemoving ? /* @__PURE__ */ React73.createElement(Spinner, { className: "w-6 h-6 text-red-500 animate-spin" }) : /* @__PURE__ */ React73.createElement(HiOutlineTrash, { className: "w-6 h-6 text-red-500" })
  )));
};
var getFileInfo = (fileUrl) => {
  const fileName = fileUrl.split("/").pop();
  return {
    fileName,
    isImage: /\.(jpe?g|png)$/.test(fileName)
  };
};
var Button2 = React73.forwardRef(function Button3({
  children: providedChildren,
  size,
  shape = "round",
  variant = "default",
  block,
  icon,
  endIcon,
  className: providedClassName,
  disabled,
  loading,
  active,
  type = "button",
  render,
  ...rest
}, forwardedRef) {
  const { controlSize } = useConfig();
  const formControlSize = useFormStyle().size;
  const inputGroupSize = useInputStyle().size;
  const sizeIconClass = "inline-flex items-center justify-center";
  const buttonSize = size || inputGroupSize || formControlSize || controlSize;
  const getButtonSize = () => {
    let sizeClass = "";
    switch (buttonSize) {
      case SIZES.LG:
        sizeClass = clsx(
          heightBySize.lg,
          icon && !providedChildren ? `${widthBySize.lg} ${sizeIconClass} text-2xl` : "px-8 py-2 text-base"
        );
        break;
      case SIZES.SM:
        sizeClass = clsx(
          heightBySize.sm,
          icon && !providedChildren ? `${widthBySize.sm} ${sizeIconClass} text-lg` : "px-3 py-2 text-sm"
        );
        break;
      case SIZES.XS:
        sizeClass = clsx(
          heightBySize.xs,
          icon && !providedChildren ? `${widthBySize.xs} ${sizeIconClass} text-base` : "px-3 py-1 text-xs"
        );
        break;
      default:
        sizeClass = clsx(
          heightBySize.md,
          icon && !providedChildren ? `${widthBySize.md} ${sizeIconClass} text-xl` : "px-8 py-2"
        );
        break;
    }
    return sizeClass;
  };
  const disabledClass = "opacity-50 cursor-not-allowed";
  const solidColor = () => {
    const btn = {
      bgColor: active ? `bg-primary-600` : `bg-primary-500`,
      textColor: "text-white",
      hoverColor: active ? "" : `hover:bg-primary-500`,
      activeColor: `active:bg-primary-600`
    };
    return getBtnColor(btn);
  };
  const twoToneColor = () => {
    const btn = {
      bgColor: active ? `bg-primary-200 dark:bg-primary-50` : `bg-primary-50 dark:bg-primary-500 dark:bg-opacity-20`,
      textColor: `text-primary-600 dark:text-primary-50`,
      hoverColor: active ? "" : `hover:bg-primary-100 dark:hover:bg-primary-500 dark:hover:bg-opacity-30`,
      activeColor: `active:bg-primary-200 dark:active:bg-primary-500 dark:active:bg-opacity-40`
    };
    return getBtnColor(btn);
  };
  const defaultColor = () => {
    const btn = {
      bgColor: active ? `bg-gray-100 border border-gray-300 dark:bg-gray-500 dark:border-gray-500` : `bg-white border border-gray-300 dark:bg-gray-700 dark:border-gray-700`,
      textColor: `text-gray-600 dark:text-gray-100`,
      hoverColor: active ? "" : `hover:bg-gray-50 dark:hover:bg-gray-600`,
      activeColor: `active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500`
    };
    return getBtnColor(btn);
  };
  const plainColor = () => {
    const btn = {
      bgColor: active ? `bg-gray-100 dark:bg-gray-500` : "bg-transparent border border-transparent",
      textColor: `text-gray-600 dark:text-gray-100`,
      hoverColor: active ? "" : `hover:bg-gray-50 dark:hover:bg-gray-600`,
      activeColor: `active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500`
    };
    return getBtnColor(btn);
  };
  const dangerColor = () => {
    const btn = {
      bgColor: active ? `bg-red-700` : `bg-red-600`,
      textColor: "text-white",
      hoverColor: active ? "" : `hover:bg-red-500`,
      activeColor: `active:bg-red-700`
    };
    return getBtnColor(btn);
  };
  const getBtnColor = ({
    bgColor,
    hoverColor,
    activeColor,
    textColor
  }) => {
    return `${bgColor} ${disabled || loading ? disabledClass : hoverColor + " " + activeColor} ${textColor}`;
  };
  const btnColor = () => {
    switch (variant) {
      case "solid":
        return solidColor();
      case "twoTone":
        return twoToneColor();
      case "plain":
        return plainColor();
      case "danger":
        return dangerColor();
      case "default":
        return defaultColor();
      default:
        return defaultColor();
    }
  };
  const renderChildren = () => {
    if (loading && providedChildren) {
      return /* @__PURE__ */ React73.createElement("span", { className: "flex items-center justify-center" }, /* @__PURE__ */ React73.createElement(Spinner, { enableTheme: false, className: "mr-1" }), providedChildren, endIcon);
    }
    if (icon && !providedChildren && loading) {
      return /* @__PURE__ */ React73.createElement(Spinner, { enableTheme: false });
    }
    if (icon && !providedChildren && !loading) {
      return /* @__PURE__ */ React73.createElement(React73.Fragment, null, icon);
    }
    if ((icon || endIcon) && providedChildren && !loading) {
      return /* @__PURE__ */ React73.createElement("span", { className: "flex items-center justify-center gap-2" }, icon && /* @__PURE__ */ React73.createElement("span", { className: "text-lg" }, icon), /* @__PURE__ */ React73.createElement("span", { className: "ltr:ml-1 rtl:mr-1" }, providedChildren), endIcon);
    }
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, providedChildren);
  };
  const className = clsx(
    "inline-block font-semibold focus:outline-none focus-visible:ring focus-visible:ring-primary-200 whitespace-nowrap",
    btnColor(),
    {
      round: "rounded-md",
      circle: "rounded-full",
      none: "rounded-none"
    }[shape],
    getButtonSize(),
    providedClassName,
    block && "w-full"
  );
  const children = renderChildren();
  if (render) {
    return render({
      className,
      children,
      ref: forwardedRef
    });
  }
  return /* @__PURE__ */ React73.createElement(
    "button",
    {
      ref: forwardedRef,
      className,
      type,
      ...rest,
      disabled: disabled || loading
    },
    children
  );
});

// src/components/file-upload.tsx
var FileUpload = React73.forwardRef(function FileUpload2({
  onFilesSelected,
  variant = "area",
  fileType,
  accept = fileType === "image" ? "image/*" : void 0,
  label = "Upload",
  hint = "Drag or click to select a file.",
  className,
  Icon: Icon3 = HiOutlineUpload,
  ...inputProps
}, forwardedRef) {
  const [isDragOver, setIsDragOver] = React73.useState(false);
  const generatedId = React73.useId();
  const inputId = inputProps.id || generatedId;
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("relative p-1", className) }, /* @__PURE__ */ React73.createElement(
    "input",
    {
      type: "file",
      value: "",
      accept,
      ...inputProps,
      id: inputId,
      onChange: (ev) => {
        if (ev.target.files) {
          onFilesSelected(Array.from(ev.target.files));
        }
      },
      className: "sr-only peer",
      ref: forwardedRef
    }
  ), variant === "area" ? /* @__PURE__ */ React73.createElement(
    "label",
    {
      htmlFor: inputId,
      onDragEnter: (ev) => {
        ev.preventDefault();
        setIsDragOver(true);
      },
      onDragLeave: (ev) => {
        ev.preventDefault();
        setIsDragOver(false);
      },
      onDragOver: (ev) => ev.preventDefault(),
      onDrop: (ev) => {
        ev.preventDefault();
        if (ev.dataTransfer.files) {
          onFilesSelected(Array.from(ev.dataTransfer.files));
        }
        setIsDragOver(false);
      },
      className: clsx(
        "flex justify-center items-center p-4 sm:p-6 rounded-lg border-2 border-dashed",
        inputProps.disabled ? "cursor-not-allowed bg-gray-50 opacity-60" : "cursor-pointer hover:bg-gray-50",
        isDragOver ? "border-primary-500 bg-primary-500 bg-opacity-5" : "border-gray-300",
        "peer-focus-visible:ring peer-focus-visible:ring-primary-200"
      )
    },
    /* @__PURE__ */ React73.createElement("div", { className: "text-gray-400 text-center pointer-events-auto" }, /* @__PURE__ */ React73.createElement(Icon3, { className: "inline-block w-8 h-8 text-gray-400 mb-2" }), /* @__PURE__ */ React73.createElement("div", null, label), /* @__PURE__ */ React73.createElement("div", { className: "text-xs mt-1" }, hint))
  ) : /* @__PURE__ */ React73.createElement(
    Button2,
    {
      icon: /* @__PURE__ */ React73.createElement(Icon3, { className: "w-5 h-5" }),
      render: (btnProps) => /* @__PURE__ */ React73.createElement("label", { ...btnProps, htmlFor: inputId, "aria-label": label }),
      shape: "circle",
      variant: "twoTone",
      className: "cursor-pointer disabled:cursor-not-allowed peer-focus-visible:ring peer-focus-visible:ring-primary-200",
      disabled: inputProps.disabled
    }
  ));
});
var Option = React73.forwardRef(function Option2({ highlighted, selected, label, description, leftIcon, render, ...divProps }, forwardedRef) {
  const isDisabled = divProps.disabled || divProps["aria-disabled"] && divProps["aria-disabled"] !== "false";
  const className = clsx(
    "flex items-center px-4 cursor-pointer select-none focus:outline-none",
    highlighted ? "bg-gray-50" : selected && "bg-gray-100",
    divProps.className
  );
  const children = /* @__PURE__ */ React73.createElement(React73.Fragment, null, leftIcon, /* @__PURE__ */ React73.createElement("div", { className: clsx("py-2 flex-1 overflow-hidden", !!leftIcon && "pl-3") }, /* @__PURE__ */ React73.createElement(
    "div",
    {
      className: clsx(
        "sm:text-sm leading-snug truncate",
        isDisabled ? "text-gray-500" : "text-black"
      )
    },
    label
  ), description && /* @__PURE__ */ React73.createElement(
    "div",
    {
      className: clsx(
        "text-xs font-normal leading-snug truncate",
        isDisabled ? "text-gray-400" : "text-gray-500"
      )
    },
    description
  )), selected && /* @__PURE__ */ React73.createElement(HiCheck, { className: "text-primary-600" }));
  if (render) {
    return render({
      children,
      className
    });
  }
  return /* @__PURE__ */ React73.createElement("div", { ...divProps, className, ref: forwardedRef }, children);
});
var OptGroupLabel = (props) => /* @__PURE__ */ React73.createElement(
  "div",
  {
    ...props,
    className: clsx(
      "px-4 py-3 mt-4 first:mt-0 text-xs font-bold tracking-1 text-lightgrey uppercase select-none",
      props.className
    )
  }
);
var normalizeOptions = (options) => {
  const result = [];
  options.forEach((option) => {
    if (isGroupOption(option)) {
      result.push(option);
    } else {
      if (result.length === 0 || result[result.length - 1].label !== "") {
        result.push({
          label: "",
          options: [option]
        });
      } else {
        result[result.length - 1].options.push(option);
      }
    }
  });
  return result;
};
var SELECT_ALL = "__SELECT_ALL__";
var sortOptions = (options, searchValue, {
  allowSelectAll,
  additionalFilter
} = {}) => {
  if (options.length === 0) {
    return {
      items: [],
      displayedItems: [],
      allItems: []
    };
  }
  return mapGroup(normalizeOptions(options), {
    allowSelectAll,
    filter: (options2) => {
      const result = matchSorter(options2, searchValue, {
        keys: ["label", "description"]
      });
      return additionalFilter ? result.filter(additionalFilter) : result;
    }
  });
};
var flattenOptions = (optionsOrGroups) => {
  const result = [];
  optionsOrGroups.forEach(function collect(optionOrGroup) {
    if (isGroupOption(optionOrGroup)) {
      optionOrGroup.options.forEach(collect);
    } else {
      result.push(optionOrGroup);
    }
  });
  return result;
};
var selectAllOption = {
  value: SELECT_ALL,
  label: "",
  index: 0
};
var mapGroup = (groups, {
  filter = (x) => x,
  allowSelectAll
} = {}) => {
  const groupsWithSortedOptions = groups.filter((group) => group.options.length !== 0);
  let optionIndex = allowSelectAll ? 1 : 0;
  const mappedPrependOption = allowSelectAll ? selectAllOption : void 0;
  const result = mappedPrependOption ? {
    items: [mappedPrependOption],
    displayedItems: [
      {
        options: [mappedPrependOption]
      }
    ],
    allItems: [mappedPrependOption]
  } : {
    items: [],
    displayedItems: [],
    allItems: []
  };
  groupsWithSortedOptions.forEach((group) => {
    const finalOptions = [];
    const filteredOptions = filter(group.options);
    group.options.forEach((option) => {
      if (filteredOptions.includes(option)) {
        const mappedOption = {
          ...option,
          index: optionIndex++
        };
        finalOptions.push(mappedOption);
        result.items.push(mappedOption);
        result.allItems.push(mappedOption);
      } else {
        result.allItems.push(option);
      }
    });
    if (finalOptions.length > 0) {
      result.displayedItems.push({
        groupLabel: group.label,
        options: finalOptions
      });
    }
  });
  if (allowSelectAll) {
    const totalOptionCount = result.displayedItems.reduce(
      (total, group) => total + group.options.length,
      0
    );
    if (totalOptionCount <= 2) {
      result.items.splice(0, 1);
      result.displayedItems.splice(0, 1);
      result.allItems.splice(0, 1);
      result.items.forEach((item) => {
        item.index--;
      });
    }
  }
  return result;
};
var isGroupOption = (option) => option.type === "group";
var Menu = Object.assign({}, DropdownMenuPrimitive, {
  Item: React73.forwardRef(
    function StyledMenuItem(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        DropdownMenuPrimitive.Item,
        {
          ...props,
          className: clsx(itemClass, props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  Content: React73.forwardRef(
    function StyledMenuContent({ children, style, ...props }, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        DropdownMenuPrimitive.Content,
        {
          ...props,
          style: style ? {
            ...contentStyle,
            ...style
          } : contentStyle,
          className: contentClass,
          ref: forwardedRef
        },
        /* @__PURE__ */ React73.createElement("div", { className: clsx(innerContentClass, props.className) }, children)
      );
    }
  ),
  SubTrigger: React73.forwardRef(
    function StyledSubTrigger(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        DropdownMenuPrimitive.SubTrigger,
        {
          ...props,
          className: clsx(itemClass, props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  SubContent: React73.forwardRef(
    function StyledMenuSubContent(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        DropdownMenuPrimitive.SubContent,
        {
          ...props,
          style: contentStyle,
          className: clsx(contentClass, innerContentClass, props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  RadioItem: React73.forwardRef(
    function StyledMenuRadioItem(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        DropdownMenuPrimitive.RadioItem,
        {
          ...props,
          className: clsx(itemClass, props.className),
          ref: forwardedRef
        }
      );
    }
  )
});
var itemClass = "px-3 py-2 text-sm focus:outline-none data-[highlighted]:text-gray-900 data-[highlighted]:bg-gray-200";
var contentClass = "min-w-[10rem] bg-white shadow-lg rounded-md animate-[scalein_100ms_ease-out]";
var innerContentClass = "flex flex-col gap-1 p-1 shadow rounded-md";
var contentStyle = {
  transformOrigin: "var(--radix-dropdown-menu-content-transform-origin)"
};
var IsInDialogContext = createNamedContext(false, "DialogContext");
var useIsInDialog = () => React73.useContext(IsInDialogContext);

// src/components/multi-select.tsx
var MultiSelectImpl = forwardRefWithGenerics(function MultiSelect({
  value,
  onValue,
  options,
  allowToggleAll,
  selectAllLabel = "Select all",
  unselectAllLabel = "Unselect all",
  size: size$1,
  placeholder,
  onFocus,
  className,
  name,
  required,
  ...buttonProps
}, forwardedRef) {
  const { inputId } = useFormControl();
  const selectSize = useFormControlSize(size$1);
  const optionData = React73.useMemo(() => {
    return options && sortOptions(options, "", {
      allowSelectAll: allowToggleAll
    });
  }, [options, allowToggleAll, value]);
  const selectedItems = React73.useMemo(
    () => optionData ? value.map((v) => optionData.allItems.find((opt) => opt.value === v)).filter(isDefined) : [],
    [value, optionData]
  );
  const isAllSelected = React73.useMemo(
    () => optionData && value.length === optionData.allItems.filter((opt) => opt.value !== SELECT_ALL).length,
    [optionData, value]
  );
  const { isOpen, getItemProps, getMenuProps, highlightedIndex, getToggleButtonProps } = useSelect({
    selectedItem: null,
    itemToString: (i) => i ? i.label : "",
    items: optionData ? optionData.items : [],
    stateReducer: (state, { type, changes }) => {
      if (type === useSelect.stateChangeTypes.ItemClick || type === useSelect.stateChangeTypes.ToggleButtonKeyDownEnter) {
        return {
          ...changes,
          isOpen: state.isOpen,
          highlightedIndex: state.highlightedIndex
        };
      }
      return changes;
    },
    onStateChange: ({ type, selectedItem }) => {
      switch (type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            if (selectedItem.value === SELECT_ALL) {
              if (isAllSelected) {
                onValue([]);
              } else {
                if (optionData) {
                  const result = selectedItems.slice();
                  optionData.items.forEach((item) => {
                    if (item.value !== SELECT_ALL && !result.includes(item)) {
                      result.push(item);
                    }
                  });
                  onValue(result.map((r) => r.value));
                }
              }
            } else {
              const currentIndex = value.findIndex((v) => selectedItem.value === v);
              if (currentIndex >= 0) {
                onValue(value.filter((_, index) => index !== currentIndex));
              } else {
                onValue(value.concat(selectedItem.value));
              }
            }
          }
          break;
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  const btnRef = React73.useRef(null);
  const refToApply = useComposedRefs(btnRef, forwardedRef);
  return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement("div", { className: clsx("w-full", className), ref: floatingHelpers.refs.setReference }, /* @__PURE__ */ React73.createElement(
    "button",
    {
      ...getToggleButtonProps({
        id: inputId,
        type: "button",
        ...buttonProps,
        className: clsx(
          "flex justify-between items-center w-full rounded-md",
          "border border-gray-300",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          selectSize === "lg" && "text-lg",
          heightBySize[selectSize],
          buttonProps.disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white"
        ),
        ref: refToApply
      })
    },
    /* @__PURE__ */ React73.createElement(
      "span",
      {
        className: clsx(
          "block px-3 py-2 truncate",
          !selectedItems.length && "text-gray-400 opacity-70"
        )
      },
      selectedItems.length ? selectedItems.map((item) => item.label).join(", ") : placeholder
    ),
    /* @__PURE__ */ React73.createElement("span", { className: "p-2 text-xl" }, /* @__PURE__ */ React73.createElement(HiChevronDown, { className: "text-gray-400", width: 20, height: 20 }))
  )), (required || name) && /* @__PURE__ */ React73.createElement(
    "input",
    {
      type: "hidden",
      name,
      required,
      value: selectedItems.map((i) => i.label).join(",")
    }
  ), /* @__PURE__ */ React73.createElement(Root, null, /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React73.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg"
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? /* @__PURE__ */ React73.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React73.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React73.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React73.createElement("div", null, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React73.createElement(React73.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React73.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => {
          if (option.value === SELECT_ALL) {
            return /* @__PURE__ */ React73.createElement(
              Option,
              {
                key: `${option.value}-${option.index}`,
                ...getItemProps({
                  item: option,
                  index: option.index,
                  disabled: option.disabled || buttonProps.disabled
                }),
                highlighted: option.index === highlightedIndex,
                label: isAllSelected ? unselectAllLabel : selectAllLabel,
                className: "border-b border-gray-200"
              }
            );
          }
          return /* @__PURE__ */ React73.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled || buttonProps.disabled
              }),
              leftIcon: option.icon,
              label: option.label,
              description: option.description,
              highlighted: option.index === highlightedIndex,
              selected: value.includes(option.value)
            }
          );
        })))))
      ) : /* @__PURE__ */ React73.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React73.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var MultiSelect2 = forwardRefWithGenerics(function MultiSelectOuter(props, forwardedRef) {
  const isInDialog = useIsInDialog();
  const [mounted, setMounted] = React73.useState(false);
  React73.useEffect(() => {
    setMounted(true);
  }, []);
  return isInDialog && !mounted ? /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      className: props.className,
      size: props.size,
      id: props.id,
      placeholder: props.placeholder,
      disabled: true
    }
  ) : /* @__PURE__ */ React73.createElement(MultiSelectImpl, { ...props, ref: forwardedRef });
});
var MultiSelectField = forwardRefWithGenerics(function MultiSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(MultiSelect2, { ...props, ref: forwardedRef }));
});
var MultiInputImpl = React73.forwardRef(
  function MultiInputImpl2({ size, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      "input",
      {
        ...props,
        className: clsx(
          "flex-1 min-w-[2.5rem]",
          size === "lg" && "text-lg",
          props.disabled && "placeholder:opacity-70",
          "focus:outline-none",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var MultiInputImplWrapper = React73.forwardRef(
  function MultiInputImplWrapper2({ noBorder, disabled, size, noWrap, ...props }, ref) {
    return /* @__PURE__ */ React73.createElement(
      "div",
      {
        ...props,
        className: clsx(
          "w-full flex items-center gap-x-1 gap-y-2 overflow-x-auto px-3 rounded-md",
          !noWrap && "flex-wrap",
          { xs: "py-0", sm: "py-1", md: "py-2", lg: "py-2" }[size],
          !noBorder && "border border-gray-300",
          heightBySize[size],
          disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "cursor-text",
          "focus-within:border-primary-600 focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-opacity-50",
          props.className
        ),
        ref
      }
    );
  }
);
var MultiInputBadge = React73.forwardRef(
  function MultiInputBadge2({ onDismiss, size, children, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      "span",
      {
        ...props,
        className: clsx(
          "inline-flex items-center gap-1 px-2 rounded-full select-none",
          "bg-gray-100 text-gray-800",
          size === "lg" && "text-lg py-0.5",
          props.className
        ),
        ref: forwardedRef
      },
      children,
      /* @__PURE__ */ React73.createElement(
        "button",
        {
          type: "button",
          onClick: onDismiss,
          className: "flex-shrink-0 text-gray-600",
          tabIndex: -1
        },
        /* @__PURE__ */ React73.createElement(HiX, { className: "w-3 h-3" })
      )
    );
  }
);

// src/components/multi-text-input.tsx
var MultiTextInput = React73.forwardRef(
  function MultiTextInput2({
    value: providedValue,
    onValue,
    includeDraft,
    size,
    placeholder,
    className,
    name,
    required,
    ...inputProps
  }, forwardedRef) {
    const inputRef = React73.useRef(null);
    const refToApply = useComposedRefs(inputRef, forwardedRef);
    const { inputId } = useFormControl();
    const inputSize = useFormControlSize(size);
    const [inputValue, setInputValue] = React73.useState("");
    const values = React73.useMemo(() => {
      const valuesCount = /* @__PURE__ */ new Map();
      const values2 = [];
      providedValue.forEach((value, index) => {
        if (includeDraft && index === providedValue.length - 1 && value === inputValue.trim()) {
          return;
        }
        const currentCount = valuesCount.get(value) || 0;
        values2.push({
          value,
          key: `${value}-${currentCount}`
        });
        valuesCount.set(value, currentCount + 1);
      });
      return values2;
    }, [providedValue, includeDraft, inputValue]);
    const { selectedItems, getSelectedItemProps, getDropdownProps, addSelectedItem } = useMultipleSelection({
      selectedItems: values,
      onSelectedItemsChange: ({ selectedItems: selectedItems2 }) => {
        if (selectedItems2) {
          onValue(selectedItems2.map((v) => v.value));
        }
      }
    });
    const removeSelectedItem = (itemIndex) => {
      const result = selectedItems.filter((_, index) => index !== itemIndex).map((v) => v.value);
      onValue(result);
    };
    const addItem = (value) => {
      const val = value.trim();
      if (val) {
        const similarValues = selectedItems.filter((item) => item.value === val);
        addSelectedItem({
          value: val,
          key: `${val}-${similarValues.length}`
        });
        setInputValue("");
      }
    };
    const handleInputChange = (ev) => {
      const value = ev.target.value;
      if (!/^,+$/.test(value) && value[value.length - 1] === ",") {
        addItem(value.slice(0, -1));
      } else {
        setInputValue(value);
        if (includeDraft) {
          const trimmedInput = value.trim();
          const currentValues = selectedItems.map((i) => i.value);
          const result = trimmedInput ? currentValues.concat(trimmedInput) : currentValues;
          onValue(result);
        }
      }
    };
    const handleKeyDown = (ev) => {
      if ((ev.key === "Tab" || ev.key === "Enter") && inputValue) {
        ev.preventDefault();
        addItem(inputValue);
      }
    };
    return /* @__PURE__ */ React73.createElement(
      MultiInputImplWrapper,
      {
        onClick: (ev) => {
          if (!inputProps.disabled && ev.target === ev.currentTarget && inputRef.current) {
            inputRef.current.focus();
          }
        },
        disabled: inputProps.disabled,
        className,
        size: inputSize
      },
      selectedItems.map((item, index) => /* @__PURE__ */ React73.createElement(
        MultiInputBadge,
        {
          key: item.key,
          onDismiss: () => removeSelectedItem(index),
          ...getSelectedItemProps({
            selectedItem: item,
            index,
            ...inputProps.disabled ? { disabled: true, tabIndex: void 0 } : {}
          }),
          size: inputSize
        },
        item.value
      )),
      /* @__PURE__ */ React73.createElement(
        MultiInputImpl,
        {
          ...getDropdownProps({
            id: inputId,
            value: inputValue,
            onChange: handleInputChange,
            onKeyDown: handleKeyDown,
            placeholder: selectedItems.length ? void 0 : placeholder,
            ...inputProps,
            ref: refToApply
          }),
          size: inputSize
        }
      ),
      (name || required) && /* @__PURE__ */ React73.createElement(
        "input",
        {
          type: "hidden",
          name,
          value: selectedItems.map((it) => it.value).join(","),
          required
        }
      )
    );
  }
);

// src/components/multi-text-field.tsx
var MultiTextField = React73.forwardRef(
  function MultiTextField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(MultiTextInput, { ...props, ref: forwardedRef }));
  }
);

// src/utils/format-number.ts
var currencyMap = /* @__PURE__ */ new Map([["MYR", "RM"]]);
var commaPositionRegex = /\B(?=(\d{3})+(?!\d))/g;
var getDisplayedCurrency = (currency) => currencyMap.get(currency) || currency;
function insertThousandSeparator(number) {
  const numString = String(number);
  if (numString.includes(".")) {
    const [integer, decimal] = numString.split(".");
    return `${integer.replace(commaPositionRegex, ",")}.${decimal}`;
  }
  return numString.replace(commaPositionRegex, ",");
}
var numberFormatters = {};
var formatNumber = (value, { minDecimal = 2, maxDecimal = 2, currency } = {}) => {
  if (isNil(value)) {
    return "";
  }
  const numValue = typeof value === "number" ? value : Number(value);
  let displayValue = "";
  if (isNaN(numValue)) {
    return value;
  }
  if (featureCheck.intlNumberFormat) {
    const cacheKey = `${minDecimal}-${maxDecimal}`;
    if (!numberFormatters[cacheKey]) {
      numberFormatters[cacheKey] = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: minDecimal,
        maximumFractionDigits: maxDecimal,
        currency
      });
    }
    displayValue = numberFormatters[cacheKey].format(numValue);
  } else {
    const currencyDisplay = currency && getDisplayedCurrency(currency);
    const displayedNumber = insertThousandSeparator(numValue.toFixed(maxDecimal));
    displayValue = currencyDisplay ? `${currencyDisplay} ${displayedNumber}` : displayedNumber;
  }
  return displayValue;
};

// src/components/number-input.tsx
var NumberInputImpl = React73.forwardRef(function NumberInput({
  decimalPlaces = 2,
  onValue: onChangeValue,
  allowTrailingZero,
  allowNegative,
  max,
  ...inputProps
}, forwardedRef) {
  const { value, onChange } = useRifm({
    value: parseNumber(inputProps.value, decimalPlaces === 0, max, allowNegative),
    onChange: (newVal) => {
      const parsedValue = parseNumber(newVal, decimalPlaces === 0, max, allowNegative);
      onChangeValue && onChangeValue(parsedValue);
      inputProps.onChange && inputProps.onChange(parsedValue);
    },
    accept: /[\d.-]/g,
    format: (val) => formatFixedPointNumber(val, decimalPlaces, max, allowTrailingZero, allowNegative)
  });
  return /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      inputMode: decimalPlaces ? "decimal" : "numeric",
      ...inputProps,
      value,
      onChange,
      ref: forwardedRef
    }
  );
});
var getNumberValue = (value) => {
  if (isNumber(value)) {
    return value;
  }
  if (value === "" || value === "-") {
    return void 0;
  }
  const numValue = Number(value);
  return isNaN(numValue) ? void 0 : numValue;
};
var NumberInput2 = Object.assign(NumberInputImpl, {
  getNumberValue
});
var numberAccept = /[\d.]+/g;
var negativeNumberAccept = /[\d.-]+/g;
var integerAccept = /[\d]+/g;
var negativeIntegerAccept = /[\d-]]+/g;
var MAX_SAFE_LENGTH = 16;
var parseNumber = (stringValue, isInteger, max, allowNegative) => {
  const string = String(stringValue);
  const result = (string.match(
    allowNegative ? isInteger ? negativeIntegerAccept : negativeNumberAccept : isInteger ? integerAccept : numberAccept
  ) || []).join("").substring(0, MAX_SAFE_LENGTH);
  if (isDefined(max) && Number(result) > max) {
    let finalResult = "";
    for (let index = 0; index < result.length; index++) {
      const char = result.charAt(index);
      const newResult = `${finalResult}${char}`;
      if (Number(newResult) > max) {
        return finalResult;
      }
      finalResult = newResult;
    }
    return finalResult;
  }
  return result;
};
var formatFixedPointNumber = (value, decimalPlaces, max, allowTrailingZero, allowNegative) => {
  const parsed = parseNumber(value, decimalPlaces === 0, max, allowNegative);
  if (parsed === "-") {
    return "-";
  }
  const [head, tail] = parsed.split(".");
  const scaledTail = tail != null ? tail.slice(0, decimalPlaces) : "";
  const number = Number.parseFloat(`${head}.${scaledTail}`);
  if (Number.isNaN(number)) {
    return "";
  }
  const formatted = formatNumber(number, {
    maxDecimal: scaledTail.length,
    minDecimal: scaledTail.length
  });
  if (parsed.includes(".")) {
    const [formattedHead] = formatted.split(".");
    const formattedTail = scaledTail !== "" && scaledTail[decimalPlaces - 1] === "0" && !allowTrailingZero ? scaledTail.slice(0, -1) : scaledTail;
    return `${formattedHead}.${formattedTail}`;
  }
  return formatted;
};

// src/components/number-field.tsx
var NumberFieldImpl = React73.forwardRef(function NumberField({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(NumberInput2, { ...props, ref: forwardedRef }));
});
var NumberField2 = Object.assign(NumberFieldImpl, {
  getNumberValue: NumberInput2.getNumberValue
});
var Pagination = ({
  totalPages,
  currentPage,
  onChangePage,
  perPage,
  onChangePerPage,
  className,
  formatOption = defaultFormatOption,
  previousPageAriaLabel = "Previous page",
  nextPageAriaLabel = "Next page",
  ...props
}) => {
  const pageOptions = React73.useMemo(
    () => getPageOptions(currentPage, totalPages),
    [totalPages, currentPage]
  );
  const pageSizeOptions = React73.useMemo(() => getPageSizeOptions(perPage, formatOption), [perPage]);
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("flex justify-between items-center", className), ...props }, /* @__PURE__ */ React73.createElement("div", { className: "flex items-center" }, /* @__PURE__ */ React73.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(currentPage - 1),
      "aria-label": previousPageAriaLabel,
      disabled: currentPage === 1
    },
    /* @__PURE__ */ React73.createElement(HiChevronLeft, { "aria-hidden": true, width: 20, height: 20, className: "w-5 h-5" })
  ), pageOptions.map((page) => /* @__PURE__ */ React73.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(page),
      current: page === currentPage,
      key: page
    },
    page
  )), /* @__PURE__ */ React73.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(currentPage + 1),
      "aria-label": nextPageAriaLabel,
      disabled: currentPage >= totalPages
    },
    /* @__PURE__ */ React73.createElement(HiChevronRight, { "aria-hidden": true, width: 20, height: 20, className: "w-5 h-5" })
  )), /* @__PURE__ */ React73.createElement("div", { className: "w-48 px-3" }, /* @__PURE__ */ React73.createElement(
    Select,
    {
      onValueChange: (newPerPage) => {
        onChangePerPage(Number(newPerPage));
        onChangePage(1);
      },
      value: String(perPage)
    },
    /* @__PURE__ */ React73.createElement(SelectTrigger, { size: "sm" }, /* @__PURE__ */ React73.createElement(SelectValue, null)),
    /* @__PURE__ */ React73.createElement(SelectContent, null, pageSizeOptions.map((option) => /* @__PURE__ */ React73.createElement(
      SelectItem,
      {
        key: option.value,
        value: !isString$1(option.value) ? String(option.value) : option.value
      },
      option.label
    )))
  )));
};
var defaultPageSizeOptions = [10, 20, 50, 100];
var defaultFormatOption = (pageSize) => `${pageSize} / page`;
var getPageSizeOptions = (currentPageSize, formatOption) => {
  const options = function getOptions() {
    if (defaultPageSizeOptions.includes(currentPageSize)) {
      return defaultPageSizeOptions;
    }
    return defaultPageSizeOptions.concat(currentPageSize).sort((a, b) => a - b);
  }();
  return options.map((size) => ({
    label: formatOption(size),
    value: String(size)
  }));
};
var PaginationButton = ({
  current,
  ...props
}) => /* @__PURE__ */ React73.createElement(
  "button",
  {
    type: "button",
    className: clsx(
      "relative mx-1 rounded inline-flex items-center h-8 w-8 justify-center text-sm font-semibold select-none transition-colors",
      current && "text-primary-600 bg-primary-50",
      !props.disabled && (current ? "hover:bg-primary-100" : "hover:bg-gray-100"),
      props.disabled ? "text-gray-500 opacity-50" : "text-gray-900"
    ),
    "aria-current": current,
    ...props
  }
);
var getPageOptions = (current, max) => {
  if (max <= MAX_OPTIONS_COUNT) {
    return createArray(max).map(mapOption);
  }
  if (current <= MAX_OPTIONS_COUNT - half) {
    return createArray(MAX_OPTIONS_COUNT).map(mapOption);
  }
  if (max - current <= half) {
    return createArray(MAX_OPTIONS_COUNT).map((_, index) => max - index).reverse();
  }
  return createArray(MAX_OPTIONS_COUNT).map((_, index) => current + index - half);
};
var MAX_OPTIONS_COUNT = 5;
var mapOption = (_, index) => index + 1;
var half = Math.floor(MAX_OPTIONS_COUNT / 2);
var createArray = (length) => Array.from({ length });
var PasswordInput = React73.forwardRef(
  function PasswordInput2(props, forwardedRef) {
    const [showPassword, toggleShowPassword] = React73.useReducer((x) => !x, false);
    const hideMsEdgePasswordReveal = `
    input[type="password"]::-ms-reveal {
      display: none;
    }
  `;
    return /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement("style", null, hideMsEdgePasswordReveal), /* @__PURE__ */ React73.createElement(
      TextInput,
      {
        ...props,
        type: showPassword ? "text" : "password",
        ref: forwardedRef,
        suffix: /* @__PURE__ */ React73.createElement(
          "button",
          {
            onClick: toggleShowPassword,
            type: "button",
            className: "p-2 text-gray-600 rounded-full hover:bg-gray-100"
          },
          showPassword ? /* @__PURE__ */ React73.createElement(HiOutlineEye, null) : /* @__PURE__ */ React73.createElement(HiOutlineEyeOff, null)
        )
      }
    ));
  }
);

// src/components/password-field.tsx
var PasswordField = React73.forwardRef(
  function PasswordField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(PasswordInput, { ...props, ref: forwardedRef }));
  }
);
var TextHighlight = (props) => /* @__PURE__ */ React73.createElement(Highlighter, { highlightClassName: "bg-primary-200", autoEscape: true, ...props });

// src/components/searchable-select.tsx
var SearchableSelectImpl = forwardRefWithGenerics(function SearchableSelect({
  value,
  onValue,
  options,
  wrapperClass,
  id,
  onFocus,
  onInputValueChange,
  initialLabel = isString(value) ? value : String(value),
  menuClass,
  size: size$1,
  prefix,
  suffix,
  menuAlignStart,
  allowFreeText,
  ...inputProps
}, forwardedRef) {
  const { inputId: fieldId } = useFormControl();
  const inputId = id || fieldId;
  const [inputValue, setInputValue] = React73.useState(() => String(value));
  const trimmedInput = inputValue.trim();
  const [cachedItem, setCachedItem] = React73.useState(void 0);
  const validCachedItem = cachedItem && (cachedItem.value === value ? cachedItem : void 0);
  const optionData = React73.useMemo(() => {
    const removedOption = function findRemovedOption() {
      if (!validCachedItem) {
        return void 0;
      }
      if (!options) {
        return validCachedItem;
      }
      for (let index = 0; index < options.length; index++) {
        const option = options[index];
        if (option.type === "group") {
          for (let oIndex = 0; oIndex < option.options.length; oIndex++) {
            const childOption = option.options[oIndex];
            if (childOption.value === validCachedItem.value) {
              return void 0;
            }
          }
        } else {
          if (option.value === validCachedItem.value) {
            return void 0;
          }
        }
      }
      return validCachedItem;
    }();
    if (!options) {
      return removedOption ? sortOptions([removedOption], trimmedInput) : void 0;
    }
    return sortOptions(removedOption ? options.concat(removedOption) : options, trimmedInput);
  }, [options, trimmedInput, validCachedItem]);
  const selectedItem = React73.useMemo(() => {
    if (!value || !optionData) {
      return null;
    }
    return optionData.allItems.find((o) => o.value === value) || null;
  }, [value, optionData]);
  const displayedValue = React73.useMemo(() => {
    const fallbackValue = allowFreeText ? value : "";
    if (!optionData) {
      return fallbackValue;
    }
    const selectedOption = optionData.allItems.find((item) => item.value === value);
    return selectedOption ? selectedOption.label : fallbackValue;
  }, [optionData, value, allowFreeText]);
  React73.useEffect(() => {
    setInputValue(displayedValue);
  }, [displayedValue]);
  const {
    isOpen,
    openMenu,
    closeMenu,
    highlightedIndex,
    getInputProps,
    getItemProps,
    getToggleButtonProps,
    getMenuProps,
    selectItem
  } = useCombobox({
    inputValue,
    selectedItem,
    items: optionData && optionData.items || [],
    itemToString: (i) => i ? i.label : "",
    inputId,
    onSelectedItemChange: (changes) => {
      const selectedItem2 = changes.selectedItem;
      if (selectedItem2) {
        onValue(selectedItem2.value, selectedItem2.label);
        setCachedItem(selectedItem2);
      } else {
        onValue("", "");
      }
    },
    onStateChange: (change) => {
      if (allowFreeText) {
        if (change.type === useCombobox.stateChangeTypes.InputBlur) {
          if (inputValue !== displayedValue && inputValue !== value) {
            onValue(inputValue, inputValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (change.inputValue === "") {
            setInputValue("");
            onInputValueChange && onInputValueChange("");
            if (allowFreeText) {
              onValue("", "");
            }
          } else {
            if (inputValue !== displayedValue && inputValue !== value) {
              onValue(inputValue, inputValue);
            }
          }
        }
      } else {
        if (change.type === useCombobox.stateChangeTypes.InputBlur || change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (inputValue !== displayedValue) {
            setInputValue(displayedValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape && change.inputValue === "") {
          setInputValue("");
          onInputValueChange && onInputValueChange("");
        }
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: menuAlignStart ? [] : [
      size({
        apply({ rects, elements }) {
          if (rects.reference.width > rects.floating.width) {
            Object.assign(elements.floating.style, {
              width: `${rects.reference.width}px`
            });
          }
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement("div", { className: clsx("relative", wrapperClass), ref: floatingHelpers.refs.setReference }, /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      onValue: callAll(
        onInputValueChange && ((val) => onInputValueChange(val.trim())),
        setInputValue,
        (newVal) => {
          if (newVal === "" && selectedItem) {
            selectItem(null);
          }
        }
      ),
      size: size$1,
      prefix,
      suffix,
      ...getInputProps({
        value: inputValue,
        onFocus: callAll(onFocus, () => {
          if (!isOpen) {
            openMenu();
          }
        }),
        ref: forwardedRef,
        ...inputProps
      })
    }
  ), !allowFreeText && /* @__PURE__ */ React73.createElement(
    "button",
    {
      ...getToggleButtonProps({
        type: "button",
        className: "absolute inset-y-0 right-0 flex items-center p-2 text-gray-400",
        disabled: inputProps.disabled
      })
    },
    /* @__PURE__ */ React73.createElement(HiChevronDown, { width: 20, height: 20, "aria-hidden": true, className: "w-5 h-5" })
  )), /* @__PURE__ */ React73.createElement(Root, null, /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React73.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg",
            menuClass
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? allowFreeText ? null : /* @__PURE__ */ React73.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React73.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React73.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React73.createElement("div", { onFocus: () => closeMenu() }, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React73.createElement(React73.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React73.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => /* @__PURE__ */ React73.createElement(
          Option,
          {
            key: `${option.value}-${option.index}`,
            ...getItemProps({
              item: option,
              index: option.index,
              disabled: option.disabled
            }),
            leftIcon: option.icon,
            highlighted: option.index === highlightedIndex,
            selected: option === selectedItem,
            label: /* @__PURE__ */ React73.createElement(
              TextHighlight,
              {
                searchWords: [trimmedInput],
                textToHighlight: option.label
              }
            ),
            description: option.description && /* @__PURE__ */ React73.createElement(
              TextHighlight,
              {
                textToHighlight: option.description,
                searchWords: [trimmedInput]
              }
            )
          }
        ))))))
      ) : /* @__PURE__ */ React73.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React73.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var SearchableSelect2 = forwardRefWithGenerics(function SearchableSelectOuter(props, forwardedRef) {
  const isInDialog = useIsInDialog();
  const [mounted, setMounted] = React73.useState(false);
  React73.useEffect(() => {
    setMounted(true);
  }, []);
  return isInDialog && !mounted ? /* @__PURE__ */ React73.createElement("div", { className: clsx("relative", props.wrapperClass) }, /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      className: props.className,
      value: props.value,
      size: props.size,
      prefix: props.prefix,
      suffix: props.suffix,
      id: props.id,
      disabled: true,
      ref: forwardedRef
    }
  )) : /* @__PURE__ */ React73.createElement(SearchableSelectImpl, { ...props, ref: forwardedRef });
});

// src/components/phone-input.tsx
var PhoneInput = React73.forwardRef(function PhoneInput2({ className, value, onValue, defaultCountry = "my", ...props }, forwardedRef) {
  const [countryCode, setCountryCode] = React73.useState(defaultCountry);
  const countryData = getCountryOptionsAndMap();
  const valueWithoutPrefix = React73.useMemo(() => {
    if (!value) {
      return "";
    }
    const currentCountry = countryData.map.get(countryCode);
    const prefix = currentCountry ? currentCountry.dialCode : "";
    if (value.startsWith(prefix)) {
      return value.slice(prefix.length);
    }
    return value;
  }, [value, countryCode]);
  const { inputId } = useFormControl();
  const usedId = props.id || inputId;
  return /* @__PURE__ */ React73.createElement("div", { className: clsx("flex", className) }, /* @__PURE__ */ React73.createElement("div", { className: "w-28 flex-shrink-0" }, /* @__PURE__ */ React73.createElement(
    SearchableSelect2,
    {
      value: countryCode,
      onValue: (newCountryCode) => {
        if (newCountryCode) {
          setCountryCode(newCountryCode);
          const newCountry = countryData.map.get(newCountryCode);
          if (newCountry) {
            onValue(newCountry.dialCode + valueWithoutPrefix);
          }
        }
      },
      options: countryData.options,
      id: `${usedId}__prefix`,
      className: "rounded-r-none",
      menuAlignStart: true,
      menuClass: "min-w-[15rem]",
      size: props.size,
      disabled: props.disabled
    }
  )), /* @__PURE__ */ React73.createElement(
    TextInput,
    {
      ...props,
      id: usedId,
      value: valueWithoutPrefix,
      onValue: (inputValue) => {
        const currentCountry = countryData.map.get(countryCode);
        const prefix = currentCountry ? currentCountry.dialCode : "";
        onValue(inputValue ? prefix + inputValue : inputValue);
      },
      type: "tel",
      ref: forwardedRef,
      className: "rounded-l-none"
    }
  ));
});
var _countryOptionsAndMaps;
function getCountryOptionsAndMap() {
  if (_countryOptionsAndMaps) {
    return _countryOptionsAndMaps;
  }
  const getSvgUrl = (isoCode) => `https://country-flags-images.s3.amazonaws.com/flags/${isoCode}.svg`;
  const countryList = CountryList.getAll().map((flag) => ({
    name: flag.name,
    dialCode: flag.dialCode,
    isoCode: flag.code.toLowerCase()
  }));
  const countryMap = new Map(countryList.map((country) => [country.isoCode, country]));
  const countryOptions = countryList.map((country) => ({
    value: country.isoCode,
    label: country.dialCode || "-",
    description: country.name,
    icon: /* @__PURE__ */ React73.createElement("img", { src: getSvgUrl(country.isoCode), alt: "", className: "h-5 w-5", width: 20, height: 20 })
  }));
  _countryOptionsAndMaps = {
    options: countryOptions,
    map: countryMap
  };
  return _countryOptionsAndMaps;
}

// src/components/phone-field.tsx
var PhoneField = React73.forwardRef(function PhoneField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(PhoneInput, { ...props, className: clsx("flex-1", props.className), ref: forwardedRef }));
});
var SearchableMultiSelect = forwardRefWithGenerics(function SearchableMultiSelect2({
  value,
  onValue,
  options,
  onInputValueChange,
  allowSelectAll,
  selectAllLabel = "Select all",
  size: size$1,
  placeholder,
  onFocus,
  className,
  ...inputProps
}, forwardedRef) {
  const { inputId } = useFormControl();
  const inputSize = useFormControlSize(size$1);
  const [textInputValue, setTextInputValue] = React73.useState("");
  const trimmedInput = textInputValue.trim();
  const onInputChange = (value2) => {
    setTextInputValue(value2);
    if (onInputValueChange) {
      onInputValueChange(value2.trim());
    }
  };
  const optionData = React73.useMemo(() => {
    return options && sortOptions(options, trimmedInput, {
      allowSelectAll,
      additionalFilter: (opt) => !value.includes(opt.value)
    });
  }, [options, trimmedInput, allowSelectAll, value]);
  const selectedItems = React73.useMemo(
    () => optionData ? value.map((v) => optionData.allItems.find((opt) => opt.value === v)).filter(isDefined) : [],
    [value, optionData]
  );
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems
  } = useMultipleSelection({
    selectedItems,
    onSelectedItemsChange: ({ selectedItems: selectedItems2 }) => {
      if (selectedItems2) {
        const items = selectedItems2;
        onValue(items.map((i) => i.value));
      }
    }
  });
  const { isOpen, getInputProps, getItemProps, getMenuProps, highlightedIndex, openMenu } = useCombobox({
    inputValue: textInputValue,
    selectedItem: null,
    itemToString: (i) => i ? i.label : "",
    items: optionData ? optionData.items : [],
    inputId,
    stateReducer: (state, { type, changes }) => {
      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        const nextHighlightedIndex = optionData && optionData.items.length === state.highlightedIndex + 1 ? state.highlightedIndex - 1 : state.highlightedIndex;
        return {
          ...changes,
          isOpen: state.isOpen,
          highlightedIndex: nextHighlightedIndex
        };
      }
      return changes;
    },
    onStateChange: ({ inputValue, type, selectedItem }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          onInputChange(inputValue || "");
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            onInputChange("");
            if (selectedItem.value === SELECT_ALL) {
              if (optionData) {
                const result = selectedItems.slice();
                optionData.items.forEach((item) => {
                  if (item.value !== SELECT_ALL && !result.includes(item)) {
                    result.push(item);
                  }
                });
                setSelectedItems(result);
              }
            } else {
              addSelectedItem(selectedItem);
            }
          }
          break;
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  const inputRef = React73.useRef();
  const refToApply = useComposedRefs(inputRef, forwardedRef);
  return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
    MultiInputImplWrapper,
    {
      size: inputSize,
      className: clsx("relative", className),
      ref: floatingHelpers.refs.setReference
    },
    selectedItems.map((selectedItem, index) => /* @__PURE__ */ React73.createElement(
      MultiInputBadge,
      {
        key: `selectedItem-${index}`,
        onDismiss: (ev) => {
          ev.stopPropagation();
          removeSelectedItem(selectedItem);
          if (!isOpen) {
            openMenu();
          }
        },
        size: inputSize,
        ...getSelectedItemProps({
          selectedItem,
          index,
          ...inputProps.disabled && {
            disabled: true,
            tabIndex: void 0
          }
        })
      },
      selectedItem.label
    )),
    /* @__PURE__ */ React73.createElement(
      MultiInputImpl,
      {
        ...getInputProps(
          getDropdownProps({
            onFocus: callAll(onFocus, () => {
              if (!isOpen) {
                openMenu();
              }
            }),
            placeholder: selectedItems.length ? void 0 : placeholder,
            ref: refToApply
          })
        ),
        size: inputSize
      }
    )
  ), /* @__PURE__ */ React73.createElement(Root, null, /* @__PURE__ */ React73.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React73.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg"
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? /* @__PURE__ */ React73.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React73.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React73.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React73.createElement("div", null, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React73.createElement(React73.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React73.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => {
          if (option.value === SELECT_ALL) {
            return /* @__PURE__ */ React73.createElement(
              Option,
              {
                key: `${option.value}-${option.index}`,
                ...getItemProps({
                  item: option,
                  index: option.index,
                  disabled: option.disabled || inputProps.disabled
                }),
                highlighted: option.index === highlightedIndex,
                label: selectAllLabel,
                className: "border-b border-gray-200"
              }
            );
          }
          return /* @__PURE__ */ React73.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled || inputProps.disabled
              }),
              leftIcon: option.icon,
              highlighted: option.index === highlightedIndex,
              label: /* @__PURE__ */ React73.createElement(
                TextHighlight,
                {
                  textToHighlight: option.label,
                  searchWords: [trimmedInput]
                }
              ),
              description: option.description && /* @__PURE__ */ React73.createElement(
                TextHighlight,
                {
                  textToHighlight: option.description,
                  searchWords: [trimmedInput]
                }
              )
            }
          );
        })))))
      ) : /* @__PURE__ */ React73.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React73.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var SearchableMultiSelectField = forwardRefWithGenerics(
  function SearchableMultiSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(SearchableMultiSelect, { ...props, ref: forwardedRef }));
  }
);
var Command = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  Command$1,
  {
    ref,
    className: cn(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      className
    ),
    ...props
  }
));
Command.displayName = Command$1.displayName;
var CommandDialog = ({ children, ...props }) => {
  return /* @__PURE__ */ React73.createElement(Dialog, { ...props }, /* @__PURE__ */ React73.createElement(DialogContent, { className: "overflow-hidden p-0 shadow-lg" }, /* @__PURE__ */ React73.createElement(Command, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5" }, children)));
};
var CommandInput = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "" }, /* @__PURE__ */ React73.createElement(FiSearch, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }), /* @__PURE__ */ React73.createElement(
  Command$1.Input,
  {
    ref,
    className: cn(
      "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
      className
    ),
    ...props
  }
)));
CommandInput.displayName = Command$1.Input.displayName;
var CommandList = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  Command$1.List,
  {
    ref,
    className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
    ...props
  }
));
CommandList.displayName = Command$1.List.displayName;
var CommandEmpty = React73.forwardRef((props, ref) => /* @__PURE__ */ React73.createElement(Command$1.Empty, { ref, className: "py-6 text-center text-sm", ...props }));
CommandEmpty.displayName = Command$1.Empty.displayName;
var CommandGroup = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  Command$1.Group,
  {
    ref,
    className: cn(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      className
    ),
    ...props
  }
));
CommandGroup.displayName = Command$1.Group.displayName;
var CommandSeparator = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  Command$1.Separator,
  {
    ref,
    className: cn("-mx-1 h-px bg-border", className),
    ...props
  }
));
CommandSeparator.displayName = Command$1.Separator.displayName;
var CommandItem = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  Command$1.Item,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
      className
    ),
    ...props
  }
));
CommandItem.displayName = Command$1.Item.displayName;
var CommandShortcut = ({ className, ...props }) => {
  return /* @__PURE__ */ React73.createElement(
    "span",
    {
      className: cn("ml-auto text-xs tracking-widest text-muted-foreground", className),
      ...props
    }
  );
};
CommandShortcut.displayName = "CommandShortcut";

// src/components/ui/searchable-select.tsx
function SearchableSelect3({
  options,
  placeholder = "Select an option",
  emptyMessage = "No results found.",
  onChange,
  noBorder,
  size,
  disabled
}) {
  const [open, setOpen] = React73.useState(false);
  const [value, setValue] = React73.useState("");
  const handleSelect = React73.useCallback(
    (currentValue) => {
      setValue(currentValue === value ? "" : currentValue);
      setOpen(false);
      onChange?.(currentValue);
    },
    [value, onChange]
  );
  const selectSize = useFormControlSize(size || "sm");
  return /* @__PURE__ */ React73.createElement(Popover, { open, onOpenChange: setOpen }, /* @__PURE__ */ React73.createElement(
    PopoverTrigger,
    {
      asChild: true,
      className: cn(
        !noBorder && "border border-gray-300",
        selectSize === "lg" && "text-lg",
        heightBySize[selectSize],
        open && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
        "focus:outline-none focus:ring-2 focus:border-primary-600 focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50",
        "data-[placeholder]:text-gray-400",
        disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white"
      )
    },
    /* @__PURE__ */ React73.createElement(
      Button,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": open,
        className: "min-w-[200px] justify-between"
      },
      value ? options.find((option) => option.value === value)?.label : placeholder,
      /* @__PURE__ */ React73.createElement(HiChevronDown, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
    )
  ), /* @__PURE__ */ React73.createElement(PopoverContent, { className: "w-full min-w-[200px] p-0" }, /* @__PURE__ */ React73.createElement(Command, null, /* @__PURE__ */ React73.createElement(CommandInput, { placeholder: "Search options..." }), /* @__PURE__ */ React73.createElement(CommandList, null, /* @__PURE__ */ React73.createElement(CommandEmpty, null, emptyMessage), /* @__PURE__ */ React73.createElement(CommandGroup, null, options.map((option) => /* @__PURE__ */ React73.createElement(
    CommandItem,
    {
      className: "data-[disabled]:pointer-events-auto",
      key: option.value,
      value: option.value,
      onSelect: handleSelect
    },
    /* @__PURE__ */ React73.createElement(
      HiCheck,
      {
        className: cn(
          "mr-2 h-4 w-4",
          value === option.value ? "opacity-100" : "opacity-0"
        )
      }
    ),
    option.label
  )))))));
}
var SearchableSelectField = React73.forwardRef(function SearchableSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(
    SearchableSelect2,
    {
      ...props,
      wrapperClass: clsx(props.wrapperClass, "flex-1"),
      ref: forwardedRef
    }
  ));
});
var SelectField = forwardRefWithGenerics(function SelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  const [open, setOpen] = React73.useState(false);
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(
    Select,
    {
      open,
      onOpenChange: setOpen,
      onValueChange: (value) => {
        if (value !== "" && props.onValue) {
          props.onValue(value);
        }
      },
      value: !isString$1(props.value) ? props.value?.toString() : props.value
    },
    /* @__PURE__ */ React73.createElement(SelectTrigger, { open, ref: forwardedRef, disabled: props.disabled, size: props.size }, /* @__PURE__ */ React73.createElement(SelectValue, { placeholder: props.placeholder })),
    /* @__PURE__ */ React73.createElement(SelectContent, null, props.options.map((option) => /* @__PURE__ */ React73.createElement(
      SelectItem,
      {
        key: option.value,
        value: !isString$1(option.value) ? option.value?.toString() : option.value
      },
      option.label.toLowerCase() === option.label ? capitalCase(option.label) : option.label
    )))
  ));
});
var Content9 = ({ children, ...props }) => /* @__PURE__ */ React73.createElement(TooltipPrimitive.Portal, null, /* @__PURE__ */ React73.createElement(
  TooltipPrimitive.TooltipContent,
  {
    ...props,
    style: {
      backgroundColor: "#2D333A",
      boxShadow: `hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px`,
      transformOrigin: "var(--radix-tooltip-content-transform-origin)"
    },
    className: clsx(
      "text-xs px-4 py-2 text-white rounded-lg animate-[scalein_100ms_ease-out]",
      props.className
    )
  },
  children,
  /* @__PURE__ */ React73.createElement(TooltipPrimitive.Arrow, { fill: "#2D333A" })
));
var Tooltip = Object.assign({}, TooltipPrimitive, { Content: Content9 });
var TextTooltip = ({
  children,
  text,
  delayDuration,
  ...contentProps
}) => /* @__PURE__ */ React73.createElement(Tooltip.Root, { delayDuration }, /* @__PURE__ */ React73.createElement(Tooltip.Trigger, { asChild: true }, children), /* @__PURE__ */ React73.createElement(Tooltip.Content, { sideOffset: 8, ...contentProps }, text));

// src/components/sidebar.tsx
var Sidebar = ({
  variant = "gray",
  width,
  header,
  items,
  selectedKey,
  renderLink,
  onNavigate,
  className,
  getHasPendingModification
}) => {
  const [containerRef] = useAutoAnimate({
    duration: 150
  });
  return /* @__PURE__ */ React73.createElement(
    "div",
    {
      className: clsx(
        "relative flex flex-col flex-shrink-0 transition-all overflow-hidden",
        {
          gray: "bg-gray-100",
          primary: "bg-primary-500"
        }[variant],
        width && {
          collapsed: "w-0",
          expanded: "w-72",
          full: "w-full"
        }[width],
        className
      )
    },
    width !== "collapsed" && /* @__PURE__ */ React73.createElement("div", { className: "flex-1 flex flex-col gap-2 p-4 overflow-y-auto", ref: containerRef }, header, items.map((item, index) => /* @__PURE__ */ React73.createElement(
      SidebarItem,
      {
        item,
        selectedKey,
        variant,
        renderLink,
        onNavigate,
        key: item.key || index,
        getHasPendingModification
      }
    )))
  );
};
var SidebarItem = (props) => {
  const { icon, name, label = name, route, children: childItems, meta } = props.item;
  const hasPendingModification = props.getHasPendingModification(meta?.modificationEntityTypes);
  const [expanded, toggle] = React73.useReducer(
    (prevState) => !prevState,
    props.selectedKey === route || !!childItems && childItems.some((child) => child.route === props.selectedKey)
  );
  const isActive = !!route && route === props.selectedKey;
  const hasChildren = !!childItems && childItems.length > 0;
  return /* @__PURE__ */ React73.createElement(React73.Fragment, null, route && !hasChildren ? /* @__PURE__ */ React73.createElement(
    NavLink,
    {
      item: props.item,
      isActive,
      variant: props.variant,
      collapsed: props.collapsed,
      renderLink: props.renderLink,
      getHasPendingModification: props.getHasPendingModification
    }
  ) : props.collapsed ? /* @__PURE__ */ React73.createElement(
    SidebarMenuItem,
    {
      item: props.item,
      variant: props.variant,
      selectedKey: props.selectedKey,
      onNavigate: props.onNavigate,
      root: true
    }
  ) : /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(
    "button",
    {
      onClick: toggle,
      className: clsx(
        getLinkClass(props.variant, isActive, props.collapsed),
        "justify-between"
      ),
      type: "button"
    },
    /* @__PURE__ */ React73.createElement("span", { className: clsx("flex-1 flex items-center gap-3 w-full") }, React73.isValidElement(icon) ? React73.cloneElement(icon, {
      className: clsx(
        "w-6 h-6 flex-shrink-0 text-inherit",
        icon.props.className
      ),
      width: 24,
      height: 24
    }) : icon, /* @__PURE__ */ React73.createElement(
      "span",
      {
        className: clsx(
          "flex-1 text-left truncate transition-all",
          props.collapsed && "sr-only"
        )
      },
      label
    ), hasPendingModification && /* @__PURE__ */ React73.createElement("span", { className: cn("w-2 h-2 rounded-full", "bg-red-500"), "aria-hidden": "true" })),
    !props.collapsed && /* @__PURE__ */ React73.createElement(
      HiChevronDown,
      {
        className: clsx(
          "w-5 h-5 transition-transform",
          expanded ? "rotate-180" : "rotate-0"
        ),
        width: 20,
        height: 20,
        "aria-hidden": true
      }
    )
  ), expanded && childItems && hasChildren && /* @__PURE__ */ React73.createElement("div", { className: "pl-4" }, childItems.map((item, i) => /* @__PURE__ */ React73.createElement(
    SidebarItem,
    {
      item,
      selectedKey: props.selectedKey,
      variant: props.variant,
      renderLink: props.renderLink,
      onNavigate: props.onNavigate,
      key: item.key || i,
      getHasPendingModification: props.getHasPendingModification
    }
  )))));
};
var SidebarMenuItem = (props) => {
  const { item } = props;
  let hasActiveChild = false;
  const contentItems = item.children?.map((child, index) => {
    const { route, label } = child;
    if (route) {
      const isActive = route === props.selectedKey;
      if (isActive) {
        hasActiveChild = true;
      }
      return /* @__PURE__ */ React73.createElement(
        Menu.Item,
        {
          onSelect: () => props.onNavigate(route),
          className: isActive ? "bg-gray-100" : "",
          key: route
        },
        label
      );
    }
    if (child.children && Array.isArray(child.children) && child.children.length > 0) {
      return /* @__PURE__ */ React73.createElement(
        SidebarMenuItem,
        {
          item: child,
          selectedKey: props.selectedKey,
          variant: props.variant,
          onNavigate: props.onNavigate,
          key: `sub-${index}`
        }
      );
    }
    return null;
  });
  if (props.root) {
    return /* @__PURE__ */ React73.createElement(Menu.Root, null, /* @__PURE__ */ React73.createElement(TextTooltip, { text: item.label, side: "right" }, /* @__PURE__ */ React73.createElement(
      Menu.Trigger,
      {
        className: clsx(
          getLinkClass(props.variant, hasActiveChild, true),
          "data-[state=open]:bg-gray-300 data-[state=open]:text-gray-900"
        )
      },
      React73.isValidElement(item.icon) ? React73.cloneElement(item.icon, {
        className: clsx("w-6 h-6 text-inherit", item.icon.props.className),
        width: 24,
        height: 24
      }) : item.icon,
      /* @__PURE__ */ React73.createElement("span", { className: "sr-only" }, item.label)
    )), /* @__PURE__ */ React73.createElement(Menu.Portal, null, /* @__PURE__ */ React73.createElement(Menu.Content, { side: "right", sideOffset: 2, align: "start", alignOffset: -2 }, /* @__PURE__ */ React73.createElement(Menu.Label, { className: "text-xs px-3 py-1 font-medium text-gray-600" }, item.label), contentItems)));
  } else {
    return /* @__PURE__ */ React73.createElement(Menu.Sub, null, /* @__PURE__ */ React73.createElement(Menu.SubTrigger, { className: "flex justify-between items-center gap-2" }, item.label, /* @__PURE__ */ React73.createElement(HiChevronRight, null)), /* @__PURE__ */ React73.createElement(Menu.SubContent, null, contentItems));
  }
};
var NavLink = React73.forwardRef(function NavLink2({ item, isActive, collapsed, variant, renderLink, getHasPendingModification }, forwardedRef) {
  const { label = item.name } = item;
  const hasPendingModification = getHasPendingModification(item.meta?.modificationEntityTypes);
  const content = renderLink({
    to: item.route,
    className: getLinkClass(variant, isActive, collapsed),
    ref: forwardedRef,
    children: /* @__PURE__ */ React73.createElement(React73.Fragment, null, React73.isValidElement(item.icon) ? React73.cloneElement(item.icon, {
      className: clsx("w-6 h-6 flex-shrink-0", item.icon.props.className),
      width: 24,
      height: 24
    }) : item.icon, /* @__PURE__ */ React73.createElement("span", { className: clsx("flex-1 truncate transition-all", collapsed && "sr-only") }, label), hasPendingModification && /* @__PURE__ */ React73.createElement("span", { className: cn("w-2 h-2 rounded-full", "bg-red-500"), "aria-hidden": "true" }))
  });
  return collapsed ? /* @__PURE__ */ React73.createElement(TextTooltip, { text: item.label, side: "right" }, content) : content;
});
var getLinkClass = (variant, isActive, rounded) => clsx(
  "w-full flex items-center gap-3 py-2 text-sm overflow-hidden",
  "focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
  {
    primary: clsx(
      "hover:bg-primary-800",
      isActive ? "text-white bg-primary-700" : "text-gray-100"
    ),
    gray: clsx(
      "transition-colors hover:bg-gray-300",
      isActive ? "text-gray-900 bg-gray-200" : "text-gray-600 hover:text-gray-900"
    )
  }[variant],
  rounded ? "rounded-full px-2" : "rounded-md px-3"
);
var StatsCard = ({ items, isLoading, ...props }) => {
  return /* @__PURE__ */ React73.createElement(Card, { ...props, className: clsx("@container", isLoading && "animate-pulse", props.className) }, /* @__PURE__ */ React73.createElement("dl", { className: "flex flex-col @md:flex-row px-5 @md:px-0 @md:py-5 divide-y @md:divide-y-0 @md:divide-x" }, items.map((item, index) => /* @__PURE__ */ React73.createElement("div", { className: "flex-1 py-5 @md:py-0 @md:px-5", key: index }, /* @__PURE__ */ React73.createElement("dt", { className: "text-sm text-gray-500" }, item.label), /* @__PURE__ */ React73.createElement("dd", { className: "text-2xl mt-1 font-semibold whitespace-nowrap" }, isLoading ? /* @__PURE__ */ React73.createElement(Skeleton, { heightClass: "h-8" }) : item.value)))));
};
var Switch = React73.forwardRef(function Switch2({ isLoading, ...props }, forwardedRef) {
  const { inputId } = useFormControl();
  return /* @__PURE__ */ React73.createElement(
    Primitive6.Root,
    {
      ...props,
      id: props.id || inputId,
      className: clsx(
        "w-[42px] h-[25px] rounded-full transition-colors data-[state=checked]:bg-primary-500",
        "focus:outline-none focus-visible:ring focus-visible:ring-primary-300",
        props.disabled ? "bg-gray-300 cursor-not-allowed" : "bg-gray-200",
        isLoading && "animate-pulse",
        props.className
      ),
      ref: forwardedRef
    },
    /* @__PURE__ */ React73.createElement(
      Primitive6.SwitchThumb,
      {
        className: clsx(
          "block w-[21px] h-[21px] rounded-full translate-x-[2px] transition-transform data-[state=checked]:translate-x-[19px]",
          props.disabled ? "bg-gray-50" : "bg-white"
        )
      },
      isLoading && /* @__PURE__ */ React73.createElement(Spinner, null)
    )
  );
});
var SwitchField = React73.forwardRef(
  function SwitchField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(Switch, { ...props, ref: forwardedRef }));
  }
);
var TableDataContext = createNamedContext(
  {
    borderlessRow: false,
    hoverable: true,
    compact: false
  },
  "TableData"
);
var useTableData = () => React73.useContext(TableDataContext);
var TableImpl = React73.forwardRef(function Table({ borderlessRow = false, children, className, hoverable = true, compact = false, ...rest }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement("div", { className: "overflow-x-auto" }, /* @__PURE__ */ React73.createElement(
    "table",
    {
      className: clsx(
        "table-auto min-w-full divide-y divide-gray-200 dark:divide-gray-700",
        className
      ),
      ...rest,
      ref: forwardedRef
    },
    /* @__PURE__ */ React73.createElement(
      TableDataContext.Provider,
      {
        value: React73.useMemo(
          () => ({
            hoverable,
            compact,
            borderlessRow
          }),
          [hoverable, compact, borderlessRow]
        )
      },
      children
    )
  ));
});
var Thead = React73.forwardRef(
  function Thead2(props, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      "thead",
      {
        ...props,
        className: clsx("bg-gray-50 dark:bg-gray-700", props.className),
        ref: forwardedRef
      }
    );
  }
);
var Tbody = React73.forwardRef(
  function Tbody2(props, forwardedRef) {
    const { borderlessRow } = useTableData();
    return /* @__PURE__ */ React73.createElement(
      "tbody",
      {
        ...props,
        className: clsx(
          borderlessRow ? "divide-none" : "divide-y divide-gray-200 dark:divide-gray-700",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Tr = React73.forwardRef(
  function Tr2(props, forwardedRef) {
    return /* @__PURE__ */ React73.createElement("tr", { ...props, className: clsx("group", props.className), ref: forwardedRef });
  }
);
var Th = React73.forwardRef(
  function Th2(props, forwardedRef) {
    const { compact } = useTableData();
    return /* @__PURE__ */ React73.createElement(
      "th",
      {
        ...props,
        className: clsx(
          compact ? "px-3 py-2" : "px-6 py-3",
          "text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-100",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Td = React73.forwardRef(
  function Td2(props, forwardedRef) {
    const { compact, hoverable } = useTableData();
    return /* @__PURE__ */ React73.createElement(
      "td",
      {
        ...props,
        className: clsx(
          compact ? "px-3 py-2" : "px-6 py-4",
          hoverable && "group-hover:bg-gray-100/50 group-hover:dark:bg-gray-700/40",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var TableSorter = ({ sort }) => {
  const color = `text-primary-600`;
  const renderSort = () => {
    if (!sort) {
      return /* @__PURE__ */ React73.createElement(FaSort, null);
    }
    return sort === "desc" ? /* @__PURE__ */ React73.createElement(FaSortDown, { className: color }) : /* @__PURE__ */ React73.createElement(FaSortUp, { className: color });
  };
  return /* @__PURE__ */ React73.createElement("div", { className: "inline-flex" }, renderSort());
};
Object.assign(TableImpl, {
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Sorter: TableSorter
});
var toggleVariants = cva(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-10 px-3",
        sm: "h-9 px-2.5",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Toggle = React73.forwardRef(({ className, variant, size, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  TogglePrimitive.Root,
  {
    ref,
    className: cn(toggleVariants({ variant, size, className })),
    ...props
  }
));
Toggle.displayName = TogglePrimitive.Root.displayName;
var ToggleGroupContext = React73.createContext({
  size: "default",
  variant: "default"
});
var ToggleGroup = React73.forwardRef(({ className, variant, size, children, ...props }, ref) => {
  const toggleSize = useFormControlSize(size || "sm");
  return /* @__PURE__ */ React73.createElement(
    ToggleGroupPrimitive.Root,
    {
      ref,
      className: cn("flex items-center justify-center gap-1", heightBySize[toggleSize], className),
      ...props
    },
    /* @__PURE__ */ React73.createElement(ToggleGroupContext.Provider, { value: { variant, size } }, children)
  );
});
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
var ToggleGroupItem = React73.forwardRef(({ className, children, variant, size, ...props }, ref) => {
  const context = React73.useContext(ToggleGroupContext);
  return /* @__PURE__ */ React73.createElement(
    ToggleGroupPrimitive.Item,
    {
      ref,
      className: cn(
        toggleVariants({
          variant: context.variant || variant,
          size: context.size || size
        }),
        className
      ),
      ...props
    },
    children
  );
});
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
function ToggleSwitchGroup({ toggleItems, value, onValue, defaultValue, required, ...props }) {
  React73.useEffect(() => {
    if (!value && required) {
      onValue(props.defaultValue || toggleItems[0]?.value);
    }
  }, [value, onValue, toggleItems, required, props.defaultValue]);
  return /* @__PURE__ */ React73.createElement("div", { className: "w-full max-w-sm mx-auto" }, /* @__PURE__ */ React73.createElement(
    ToggleGroup,
    {
      type: "single",
      value,
      onValueChange: onValue,
      className: "bg-secondary rounded-full p-1 flex",
      ...props
    },
    toggleItems.map((item) => /* @__PURE__ */ React73.createElement(
      ToggleGroupItem,
      {
        key: item.value,
        value: item.value,
        "aria-label": item.label,
        className: "flex-1 data-[state=on]:bg-primary-600 data-[state=on]:text-primary-foreground rounded-full py-2 px-4 transition-all"
      },
      item.label
    ))
  ));
}

// src/components/toggle-switch-field.tsx
var ToggleSwitchField = React73.forwardRef(
  function SwitchField3({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(ToggleSwitchGroup, { ...props, ref: forwardedRef }));
  }
);
var Table3 = React73.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("div", { className: "relative w-full overflow-auto" }, /* @__PURE__ */ React73.createElement("table", { ref, className: cn("w-full caption-bottom text-sm", className), ...props }))
);
Table3.displayName = "Table";
var TableHeader = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("thead", { ref, className: cn("[&_tr]:border-b", className), ...props }));
TableHeader.displayName = "TableHeader";
var TableBody = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("tbody", { ref, className: cn("[&_tr:last-child]:border-0", className), ...props }));
TableBody.displayName = "TableBody";
var TableFooter = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  "tfoot",
  {
    ref,
    className: cn("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className),
    ...props
  }
));
TableFooter.displayName = "TableFooter";
var TableRow = React73.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
    "tr",
    {
      ref,
      className: cn(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        className
      ),
      ...props
    }
  )
);
TableRow.displayName = "TableRow";
var TableHead = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  "th",
  {
    ref,
    className: cn(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
      className
    ),
    ...props
  }
));
TableHead.displayName = "TableHead";
var TableCell = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  "td",
  {
    ref,
    className: cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", className),
    ...props
  }
));
TableCell.displayName = "TableCell";
var TableCaption = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement("caption", { ref, className: cn("mt-4 text-sm text-muted-foreground", className), ...props }));
TableCaption.displayName = "TableCaption";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = React73.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.SubTrigger,
  {
    ref,
    className: cn(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      inset && "pl-8",
      className
    ),
    ...props
  },
  children,
  /* @__PURE__ */ React73.createElement(FiChevronRight, { className: "ml-auto h-4 w-4" })
));
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.SubContent,
  {
    ref,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React73.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ React73.createElement(DropdownMenuPrimitive.Portal, null, /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
)));
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React73.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.Item,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      inset && "pl-8",
      className
    ),
    ...props
  }
));
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React73.forwardRef(({ className, children, checked, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    checked,
    ...props
  },
  /* @__PURE__ */ React73.createElement("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center" }, /* @__PURE__ */ React73.createElement(DropdownMenuPrimitive.ItemIndicator, null, /* @__PURE__ */ React73.createElement(FiCheck, { className: "h-4 w-4" }))),
  children
));
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React73.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props
  },
  /* @__PURE__ */ React73.createElement("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center" }, /* @__PURE__ */ React73.createElement(DropdownMenuPrimitive.ItemIndicator, null, /* @__PURE__ */ React73.createElement(FiCircle, { className: "h-2 w-2 fill-current" }))),
  children
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React73.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.Label,
  {
    ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className),
    ...props
  }
));
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  DropdownMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-muted", className),
    ...props
  }
));
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = ({ className, ...props }) => {
  return /* @__PURE__ */ React73.createElement("span", { className: cn("ml-auto text-xs tracking-widest opacity-60", className), ...props });
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";
var PlainButton = React73.forwardRef(function PlainTabButton({ active, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(
    "button",
    {
      type: "button",
      ...props,
      className: clsx(
        "flex justify-center items-center text-sm px-5 py-3 font-medium rounded-t border-b-2 border-transparent transition-colors",
        "data-[state=active]:text-primary-500 data-[state=active]:border-primary-500",
        active && "text-primary-500 border-primary-500",
        "disabled:text-gray-400",
        "focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var PlainList = React73.forwardRef(
  function PlainTabList(props, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      "div",
      {
        ...props,
        className: clsx(
          "flex items-center pt-1 overflow-x-auto overflow-y-hidden border-b border-gray-200",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Tabs = Object.assign({}, TabsPrimitive2, {
  PlainButton,
  PlainList,
  List: React73.forwardRef(function StyledTabList({ loop, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(TabsPrimitive2.List, { loop, asChild: true }, /* @__PURE__ */ React73.createElement(PlainList, { ...props, ref: forwardedRef }));
  }),
  Trigger: React73.forwardRef(
    function StyledTabTrigger({ value, ...props }, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(TabsPrimitive2.Trigger, { value, asChild: true }, /* @__PURE__ */ React73.createElement(PlainButton, { ...props, ref: forwardedRef }));
    }
  )
});
var Tabs2 = TabsPrimitive2.Root;
var TabsList = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  TabsPrimitive2.List,
  {
    ref,
    className: cn(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      className
    ),
    ...props
  }
));
TabsList.displayName = TabsPrimitive2.List.displayName;
var TabsTrigger = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  TabsPrimitive2.Trigger,
  {
    ref,
    className: cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      className
    ),
    ...props
  }
));
TabsTrigger.displayName = TabsPrimitive2.Trigger.displayName;
var TabsContent = React73.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React73.createElement(
  TabsPrimitive2.Content,
  {
    ref,
    className: cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    ),
    ...props
  }
));
TabsContent.displayName = TabsPrimitive2.Content.displayName;
var TabsPlainButton = React73.forwardRef(function PlainTabButton2({ active, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(
    "button",
    {
      type: "button",
      ...props,
      className: cn(
        "flex justify-center items-center text-sm px-5 py-3 font-medium rounded-t border-b-2 border-transparent transition-colors",
        "data-[state=active]:text-primary-500 data-[state=active]:border-primary-500",
        active && "text-primary-500 border-primary-500",
        "disabled:text-gray-400",
        "focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
TabsPlainButton.displayName = "TabsPlainButton";
var TagImpl = React73.forwardRef(function Tag({ color = "default", ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(
    "span",
    {
      ...props,
      ref: forwardedRef,
      className: clsx(
        "inline-flex items-center py-1 px-2.5 gap-1 text-xs font-medium leading-none whitespace-nowrap rounded-full",
        colors[color],
        props.className
      )
    }
  );
});
var colors = {
  default: "text-gray-500 border",
  amber: "bg-amber-100 text-amber-800",
  blue: "bg-blue-100 text-blue-800",
  gray: "bg-gray-100 text-gray-800",
  green: "bg-green-100 text-green-800",
  pink: "bg-pink-100 text-pink-800",
  purple: "bg-purple-100 text-purple-800",
  red: "bg-red-100 text-red-800"
};
var Tag2 = Object.assign(TagImpl, {
  colors: Object.keys(colors)
});
var TextField = React73.forwardRef(function TextField2({ id, status, label, layout, errorMessage, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement("div", { className: "flex-1" }, /* @__PURE__ */ React73.createElement(TextInput, { ...props, ref: forwardedRef }), errorMessage && /* @__PURE__ */ React73.createElement("div", { className: "text-red-600 text-sm mt-1" }, errorMessage)));
});
var StyledToast = React73.forwardRef(
  function StyledToast2(props, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      Primitive7.Root,
      {
        ...props,
        className: clsx(
          "p-3 bg-white shadow rounded [--slide-padding:theme(spacing.3)]",
          "data-[state=open]:animate-[slideinright_150ms_cubic-bezier(0.16,_1,_0.3,_1)] data-[state=closed]:animate-[disappear_100ms_ease-in]",
          "data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-transform",
          "data-[swipe=end]:animate-[swipeout_100ms_ease-out]",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Toast = Object.assign({}, Primitive7, {
  Root: StyledToast,
  Title: React73.forwardRef(
    function StyledToastTitle(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive7.Title,
        {
          ...props,
          className: clsx("text-base font-medium", props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  Description: React73.forwardRef(
    function StyledToastDescription(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive7.Description,
        {
          ...props,
          className: clsx("text-sm text-gray-600", props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  Viewport: React73.forwardRef(
    function StyledViewport(props, forwardedRef) {
      return /* @__PURE__ */ React73.createElement(
        Primitive7.Viewport,
        {
          ...props,
          className: clsx(
            "fixed bottom-0 right-0 flex flex-col gap-3 w-96 max-w-[100vw] p-6 outline-none z-[9999]",
            props.className
          ),
          ref: forwardedRef
        }
      );
    }
  ),
  Notification: React73.forwardRef(function ToastNotification({ variant, children, className, ...props }, forwardedRef) {
    return /* @__PURE__ */ React73.createElement(
      StyledToast,
      {
        ...props,
        className: clsx("flex items-start gap-2", className),
        ref: forwardedRef
      },
      /* @__PURE__ */ React73.createElement("div", { className: "flex-shrink-0 pt-1" }, /* @__PURE__ */ React73.createElement(StatusIcon, { type: variant })),
      /* @__PURE__ */ React73.createElement("div", { className: "flex-1" }, children)
    );
  })
});
var useIdUtils = () => {
  const baseId = React73.useId();
  const countRef = React73.useRef(0);
  return {
    baseId,
    getId: () => `${baseId}${countRef.current++}`
  };
};
var useIsMounted = () => {
  const isMountedRef = React73.useRef(false);
  React73.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
};

// src/utils/array.ts
function isSimilarArray(arrayOne, arrayTwo, keysToCompare) {
  if (arrayOne === arrayTwo) {
    return true;
  }
  if (arrayOne.length !== arrayTwo.length) {
    return false;
  }
  return arrayOne.every(
    (item, index) => keysToCompare ? keysToCompare.every((key) => item[key] === arrayTwo[index][key]) : item === arrayTwo[index]
  );
}
function dedupeArrayItem(array) {
  const result = [];
  const seen = /* @__PURE__ */ new Set();
  array.forEach((item) => {
    if (!seen.has(item)) {
      seen.add(item);
      result.push(item);
    }
  });
  return result;
}
function splitArray(array, predicate) {
  const matchResult = [];
  const unmatchResult = [];
  array.forEach((item) => {
    if (predicate(item)) {
      matchResult.push(item);
    } else {
      unmatchResult.push(item);
    }
  });
  return [matchResult, unmatchResult];
}

// src/utils/assert.ts
var assertExists = (value, errorMessage = "Value is not defined") => {
  if (!value) {
    throw new Error(errorMessage);
  }
};

// src/utils/format-list.ts
var formatStringList = function getImpl(isListFormatSupported) {
  if (isListFormatSupported) {
    const formatter = new Intl.ListFormat("en", { style: "long", type: "conjunction" });
    return function formatStringList2(items) {
      return formatter.format(items);
    };
  }
  return function naiveFormatStringList(items) {
    return items.join(", ");
  };
}(featureCheck.intListFormat);

// src/utils/object.ts
function pick(oriObject, keysToPick) {
  const result = {};
  keysToPick.forEach((key) => {
    result[key] = oriObject[key];
  });
  return result;
}
function omit(oriObject, keysToOmit) {
  const result = Object.assign({}, oriObject);
  keysToOmit.forEach((key) => delete result[key]);
  return result;
}
function pickAndOmit(oriObject, keys) {
  const pick2 = {};
  const omit2 = Object.assign({}, oriObject);
  keys.forEach((key) => {
    if (key in oriObject) {
      pick2[key] = oriObject[key];
    }
    delete omit2[key];
  });
  return {
    picked: pick2,
    omitted: omit2
  };
}
var useDebounce = (value, {
  waitMs = 500,
  onChange
} = {}) => {
  const [dValue, setDValue] = React73.useState(value);
  const onChangeRef = React73.useRef(onChange);
  onChangeRef.current = onChange;
  const isInitial = React73.useRef(true);
  React73.useEffect(() => {
    if (isInitial.current) {
      return;
    }
    const timerId = window.setTimeout(() => {
      setDValue(value);
      if (onChangeRef.current) {
        onChangeRef.current(value);
      }
    }, waitMs);
    return () => window.clearTimeout(timerId);
  }, [value, waitMs]);
  React73.useEffect(() => {
    isInitial.current = false;
  }, []);
  return dValue;
};
var emitter = mitt();
var usePersistedState = (initialState, storageKey) => {
  const getStoredValue = () => {
    const latestValue = window.localStorage.getItem(storageKey);
    return latestValue ? parseSafely(latestValue) : null;
  };
  const [value, setValue] = React73.useState(() => getStoredValue() || initialState);
  const latestValueRef = React73.useRef(value);
  latestValueRef.current = value;
  React73.useEffect(() => {
    const syncStorage = () => {
      const latestValue = getStoredValue();
      if (!isNil(latestValue) && latestValue !== latestValueRef.current) {
        setValue(latestValue);
      }
    };
    syncStorage();
    window.addEventListener("storage", syncStorage);
    const onChange = (data) => {
      if (data.key === storageKey) {
        if (data.value !== latestValueRef.current) {
          setValue(data.value);
        }
      }
    };
    emitter.on("change", onChange);
    return () => {
      window.removeEventListener("storage", syncStorage);
      emitter.off("change", onChange);
    };
  }, [storageKey]);
  const set2 = React73.useCallback(
    (newValue) => {
      setValue(newValue);
      if (newValue === initialState) {
        window.localStorage.removeItem(storageKey);
      } else {
        window.localStorage.setItem(storageKey, JSON.stringify(newValue));
      }
      emitter.emit("change", {
        key: storageKey,
        value: newValue
      });
    },
    [storageKey]
  );
  return [value, set2];
};
var parseSafely = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};
var THEMES = { light: "", dark: ".dark" };
var ChartContext = React73.createContext(null);
function useChart() {
  const context = React73.useContext(ChartContext);
  if (!context) {
    throw new Error("useChart must be used within a <ChartContainer />");
  }
  return context;
}
var ChartContainer = React73.forwardRef(({ id, className, children, config, ...props }, ref) => {
  const uniqueId = React73.useId();
  const chartId = `chart-${id || uniqueId.replace(/:/g, "")}`;
  return /* @__PURE__ */ React73.createElement(ChartContext.Provider, { value: { config } }, /* @__PURE__ */ React73.createElement(
    "div",
    {
      "data-chart": chartId,
      ref,
      className: cn(
        "flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        className
      ),
      ...props
    },
    /* @__PURE__ */ React73.createElement(ChartStyle, { id: chartId, config }),
    /* @__PURE__ */ React73.createElement(RechartsPrimitive.ResponsiveContainer, null, children)
  ));
});
ChartContainer.displayName = "Chart";
var ChartStyle = ({ id, config }) => {
  const colorConfig = Object.entries(config).filter(
    ([_, config2]) => config2.theme || config2.color
  );
  if (!colorConfig.length) {
    return null;
  }
  return /* @__PURE__ */ React73.createElement(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(THEMES).map(
          ([theme, prefix]) => `
${prefix} [data-chart=${id}] {
${colorConfig.map(([key, itemConfig]) => {
            const color = itemConfig.theme?.[theme] || itemConfig.color;
            return color ? `  --color-${key}: ${color};` : null;
          }).join("\n")}
}
`
        ).join("\n")
      }
    }
  );
};
var ChartTooltip = RechartsPrimitive.Tooltip;
var ChartTooltipContent = React73.forwardRef(
  ({
    active,
    payload,
    className,
    indicator = "dot",
    hideLabel = false,
    hideIndicator = false,
    label,
    labelFormatter,
    labelClassName,
    formatter,
    color,
    nameKey,
    labelKey
  }, ref) => {
    const { config } = useChart();
    const tooltipLabel = React73.useMemo(() => {
      if (hideLabel || !payload?.length) {
        return null;
      }
      const [item] = payload;
      const key = `${labelKey || item.dataKey || item.name || "value"}`;
      const itemConfig = getPayloadConfigFromPayload(config, item, key);
      const value = !labelKey && typeof label === "string" ? config[label]?.label || label : itemConfig?.label;
      if (labelFormatter) {
        return /* @__PURE__ */ React73.createElement("div", { className: cn("font-medium", labelClassName) }, labelFormatter(value, payload));
      }
      if (!value) {
        return null;
      }
      return /* @__PURE__ */ React73.createElement("div", { className: cn("font-medium", labelClassName) }, value);
    }, [
      label,
      labelFormatter,
      payload,
      hideLabel,
      labelClassName,
      config,
      labelKey
    ]);
    if (!active || !payload?.length) {
      return null;
    }
    const nestLabel = payload.length === 1 && indicator !== "dot";
    return /* @__PURE__ */ React73.createElement(
      "div",
      {
        ref,
        className: cn(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl",
          className
        )
      },
      !nestLabel ? tooltipLabel : null,
      /* @__PURE__ */ React73.createElement("div", { className: "grid gap-1.5" }, payload.map((item, index) => {
        const key = `${nameKey || item.name || item.dataKey || "value"}`;
        const itemConfig = getPayloadConfigFromPayload(config, item, key);
        const indicatorColor = color || item.payload.fill || item.color;
        return /* @__PURE__ */ React73.createElement(
          "div",
          {
            key: item.dataKey,
            className: cn(
              "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
              indicator === "dot" && "items-center"
            )
          },
          formatter && item?.value !== void 0 && item.name ? formatter(item.value, item.name, item, index, item.payload) : /* @__PURE__ */ React73.createElement(React73.Fragment, null, itemConfig?.icon ? /* @__PURE__ */ React73.createElement(itemConfig.icon, null) : !hideIndicator && /* @__PURE__ */ React73.createElement(
            "div",
            {
              className: cn(
                "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                {
                  "h-2.5 w-2.5": indicator === "dot",
                  "w-1": indicator === "line",
                  "w-0 border-[1.5px] border-dashed bg-transparent": indicator === "dashed",
                  "my-0.5": nestLabel && indicator === "dashed"
                }
              ),
              style: {
                "--color-bg": indicatorColor,
                "--color-border": indicatorColor
              }
            }
          ), /* @__PURE__ */ React73.createElement(
            "div",
            {
              className: cn(
                "flex flex-1 justify-between leading-none",
                nestLabel ? "items-end" : "items-center"
              )
            },
            /* @__PURE__ */ React73.createElement("div", { className: "grid gap-1.5" }, nestLabel ? tooltipLabel : null, /* @__PURE__ */ React73.createElement("span", { className: "text-muted-foreground" }, itemConfig?.label || item.name)),
            item.value && /* @__PURE__ */ React73.createElement("span", { className: "font-mono font-medium tabular-nums text-foreground" }, item.value.toLocaleString())
          ))
        );
      }))
    );
  }
);
ChartTooltipContent.displayName = "ChartTooltip";
var ChartLegend = RechartsPrimitive.Legend;
var ChartLegendContent = React73.forwardRef(
  ({ className, hideIcon = false, payload, verticalAlign = "bottom", nameKey }, ref) => {
    const { config } = useChart();
    if (!payload?.length) {
      return null;
    }
    return /* @__PURE__ */ React73.createElement(
      "div",
      {
        ref,
        className: cn(
          "flex items-center justify-center gap-4",
          verticalAlign === "top" ? "pb-3" : "pt-3",
          className
        )
      },
      payload.map((item) => {
        const key = `${nameKey || item.dataKey || "value"}`;
        const itemConfig = getPayloadConfigFromPayload(config, item, key);
        return /* @__PURE__ */ React73.createElement(
          "div",
          {
            key: item.value,
            className: cn(
              "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
            )
          },
          itemConfig?.icon && !hideIcon ? /* @__PURE__ */ React73.createElement(itemConfig.icon, null) : /* @__PURE__ */ React73.createElement(
            "div",
            {
              className: "h-2 w-2 shrink-0 rounded-[2px]",
              style: {
                backgroundColor: item.color
              }
            }
          ),
          itemConfig?.label
        );
      })
    );
  }
);
ChartLegendContent.displayName = "ChartLegend";
function getPayloadConfigFromPayload(config, payload, key) {
  if (typeof payload !== "object" || payload === null) {
    return void 0;
  }
  const payloadPayload = "payload" in payload && typeof payload.payload === "object" && payload.payload !== null ? payload.payload : void 0;
  let configLabelKey = key;
  if (key in payload && typeof payload[key] === "string") {
    configLabelKey = payload[key];
  } else if (payloadPayload && key in payloadPayload && typeof payloadPayload[key] === "string") {
    configLabelKey = payloadPayload[key];
  }
  return configLabelKey in config ? config[configLabelKey] : config[key];
}
var ResourceSelectField = forwardRefWithGenerics(function ResourceSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  const [open, setOpen] = React73.useState(false);
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React73.createElement(
    Select,
    {
      open,
      onOpenChange: setOpen,
      onValueChange: (value) => {
        if (value !== "" && props.onValue) {
          props.onValue(value);
        }
      },
      value: !isString$1(props.value) ? String(props.value) : props.value
    },
    /* @__PURE__ */ React73.createElement(SelectTrigger, { open, ref: forwardedRef, disabled: props.disabled }, /* @__PURE__ */ React73.createElement(SelectValue, { placeholder: props.placeholder })),
    /* @__PURE__ */ React73.createElement(SelectContent, null, props.options.map((option) => /* @__PURE__ */ React73.createElement(
      SelectItem,
      {
        key: option.value,
        value: !isString$1(option.value) ? String(option.value) : option.value
      },
      capitalCase(option.label)
    )))
  ));
});
var CustomField = React73.forwardRef(function CustomField2({ id, status, label, layout, inputComponent, ...props }, forwardedRef) {
  return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: props.required }, label), inputComponent);
});
var TextAreaInput = React73.forwardRef(
  function TextAreaInput2({ className, size, style, onValue, onChange, noBorder, rows = 3, label, ...textareaProps }, ref) {
    const inputSize = useFormControlSize(size);
    const { inputId } = useFormControl();
    return /* @__PURE__ */ React73.createElement(FieldGroup, { fieldId: textareaProps.id || inputId }, label && /* @__PURE__ */ React73.createElement(Label2, { showRequiredIndicator: textareaProps.required }, label), /* @__PURE__ */ React73.createElement(
      "textarea",
      {
        style,
        className: clsx(
          "w-full py-2 px-3 rounded-md",
          !noBorder && "border border-gray-300",
          inputSize === "lg" && "text-lg",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          className,
          textareaProps.disabled && "bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed placeholder:opacity-70"
        ),
        ref,
        onChange: callAll(onChange, onValue && ((ev) => onValue(ev.target.value))),
        rows,
        ...textareaProps,
        id: textareaProps.id || inputId
      }
    ));
  }
);
var HiddenTextInput = React73.forwardRef(
  function HiddenTextInput2({ className, style, onValue, ...inputProps }, ref) {
    const { inputId } = useFormControl();
    const inputNode = /* @__PURE__ */ React73.createElement(
      "input",
      {
        type: "hidden",
        style: { ...style },
        ref,
        onChange: callAll(onValue && ((ev) => onValue(ev.target.value))),
        ...inputProps,
        id: inputProps.id || inputId
      }
    );
    return inputNode;
  }
);

export { Alert, AlertDialog, Avatar, AvatarFallback, AvatarImage, Badge, Button, Calendar, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, ChartContainer, ChartLegend, ChartLegendContent, ChartStyle, ChartTooltip, ChartTooltipContent, Checkbox, CheckboxField, CheckboxGroup, Collapsible, CollapsibleContent2 as CollapsibleContent, CollapsibleTrigger2 as CollapsibleTrigger, Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut, ConfigProvider, CustomField, DateField, DatePicker, DateRangeField, DateRangePicker, DateRangeSelector, DateTimeField, DateTimeInput, DateTimePicker, DayPicker2 as DayPicker, DaySelector, DescList, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogLeftContent, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger, FieldGroup, FileItem, FileUpload, HiddenTextInput, IconButton, ImageItem, ImageViewer, Input, InputButton, Label2 as Label, Select2 as LegacySelect, Tabs as LegacyTabs, Menu, MultiSelect2 as MultiSelect, MultiSelectField, MultiTextField, MultiTextInput, NumberField2 as NumberField, NumberInput2 as NumberInput, Pagination, PasswordField, PasswordInput, PhoneField, PhoneInput, Popover, PopoverContent, PopoverTrigger, Progress, RemoteFileItem, ResourceSelectField, SearchableMultiSelect, SearchableMultiSelectField, SearchableSelect2 as SearchableSelect, SearchableSelectField, SearchableSelect3 as SearchableSelectV2, Select, SelectContent, SelectField, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue, Sidebar, Skeleton, Spinner, StatsCard, StatusField, Switch, SwitchField, Table3 as Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow, TableSorter, Tabs2 as Tabs, TabsContent, TabsList, TabsPlainButton, TabsTrigger, Tag2 as Tag, TextAreaInput, TextField, TextInput, TextTooltip, TimeInput, Toast, Toggle, ToggleGroup, ToggleGroupItem, ToggleSwitchField, Tooltip, assertExists, buttonVariants, callAll, cn, createNamedContext, dedupeArrayItem, flattenOptions, formatDate, formatDateRange, formatDateUtc, formatNumber, formatStringList, isDefined, isFunction, isNil, isNumber, isObject, isPrimitive, isSimilarArray, isString, omit, padEnd, padStart, pick, pickAndOmit, splitArray, stringRepeat, toggleVariants, useConfig, useDebounce, useIdUtils, useIsMounted, usePersistedState };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map